/**
 * Sous Chef Linguine - Complete Multilingual Translations
 * All content must be fully translated - no shortcuts or summarization
 * Languages: EN (default), IT, FR, ES, DE
 */

export const translations = {
  // ============================================
  // NAVIGATION & COMMON UI
  // ============================================
  nav: {
    home: {
      en: 'Home',
      it: 'Home',
      fr: 'Accueil',
      es: 'Inicio',
      de: 'Startseite'
    },
    explore: {
      en: 'Explore',
      it: 'Esplora',
      fr: 'Explorer',
      es: 'Explorar',
      de: 'Entdecken'
    },
    menuBuilder: {
      en: 'Menu Builder',
      it: 'Crea Menu',
      fr: 'Créateur de Menu',
      es: 'Crear Menú',
      de: 'Menü-Ersteller'
    },
    techniques: {
      en: 'Techniques',
      it: 'Tecniche',
      fr: 'Techniques',
      es: 'Técnicas',
      de: 'Techniken'
    },
    about: {
      en: 'About',
      it: 'Chi Siamo',
      fr: 'À Propos',
      es: 'Acerca de',
      de: 'Über Uns'
    },
    contact: {
      en: 'Contact',
      it: 'Contatti',
      fr: 'Contact',
      es: 'Contacto',
      de: 'Kontakt'
    },
    favorites: {
      en: 'Favorites',
      it: 'Preferiti',
      fr: 'Favoris',
      es: 'Favoritos',
      de: 'Favoriten'
    },
    login: {
      en: 'Login',
      it: 'Accedi',
      fr: 'Connexion',
      es: 'Iniciar Sesión',
      de: 'Anmelden'
    },
    logout: {
      en: 'Logout',
      it: 'Esci',
      fr: 'Déconnexion',
      es: 'Cerrar Sesión',
      de: 'Abmelden'
    },
    search: {
      en: 'Search recipes...',
      it: 'Cerca ricette...',
      fr: 'Rechercher des recettes...',
      es: 'Buscar recetas...',
      de: 'Rezepte suchen...'
    }
  },

  // ============================================
  // HOMEPAGE
  // ============================================
  home: {
    banner: {
      en: 'Authentic Regional Recipes Powered by Sous-Chef Linguine',
      it: 'Ricette Regionali Autentiche Powered by Sous-Chef Linguine',
      fr: 'Recettes Régionales Authentiques Propulsées par Sous-Chef Linguine',
      es: 'Recetas Regionales Auténticas Impulsadas por Sous-Chef Linguine',
      de: 'Authentische Regionale Rezepte mit Sous-Chef Linguine'
    },
    title: {
      en: 'Sous Chef Linguine',
      it: 'Sous Chef Linguine',
      fr: 'Sous Chef Linguine',
      es: 'Sous Chef Linguine',
      de: 'Sous Chef Linguine'
    },
    subtitle: {
      en: 'The Authentic Global Recipe Engine',
      it: "Il Motore di Ricette Globali Autentiche",
      fr: 'Le Moteur de Recettes Authentiques du Monde',
      es: 'El Motor de Recetas Auténticas del Mundo',
      de: 'Die Authentische Globale Rezept-Suchmaschine'
    },
    bestRecipe: {
      en: 'Best Recipe Worldwide',
      it: 'Miglior Ricetta al Mondo',
      fr: 'Meilleure Recette au Monde',
      es: 'Mejor Receta del Mundo',
      de: 'Beste Rezept Weltweit'
    },
    featured: {
      en: 'Featured Authentic Recipes',
      it: 'Ricette Autentiche in Evidenza',
      fr: 'Recettes Authentiques à la Une',
      es: 'Recetas Auténticas Destacadas',
      de: 'Ausgewählte Authentische Rezepte'
    },
    viewRecipe: {
      en: 'View Recipe',
      it: 'Vedi Ricetta',
      fr: 'Voir la Recette',
      es: 'Ver Receta',
      de: 'Rezept Ansehen'
    },
    viewMore: {
      en: 'View More Recipes',
      it: 'Vedi Altre Ricette',
      fr: 'Voir Plus de Recettes',
      es: 'Ver Más Recetas',
      de: 'Mehr Rezepte Ansehen'
    },
    loading: {
      en: 'Loading recipes...',
      it: 'Caricamento ricette...',
      fr: 'Chargement des recettes...',
      es: 'Cargando recetas...',
      de: 'Rezepte werden geladen...'
    },
    noRecipes: {
      en: 'No recipes available yet.',
      it: 'Nessuna ricetta disponibile.',
      fr: 'Aucune recette disponible.',
      es: 'No hay recetas disponibles.',
      de: 'Noch keine Rezepte verfügbar.'
    },
    reviews: {
      en: 'reviews',
      it: 'recensioni',
      fr: 'avis',
      es: 'reseñas',
      de: 'Bewertungen'
    },
    favorites: {
      en: 'favorites',
      it: 'preferiti',
      fr: 'favoris',
      es: 'favoritos',
      de: 'Favoriten'
    },

    // Features section
    features: {
      authenticity: {
        title: {
          en: 'Authenticity First',
          it: 'Autenticità Prima di Tutto',
          fr: "L'Authenticité d'Abord",
          es: 'Autenticidad Primero',
          de: 'Authentizität Zuerst'
        },
        description: {
          en: 'Every recipe validated through strict authenticity ranking.',
          it: 'Ogni ricetta validata tramite rigorosa classificazione di autenticità.',
          fr: 'Chaque recette validée par un classement strict d\'authenticité.',
          es: 'Cada receta validada mediante una estricta clasificación de autenticidad.',
          de: 'Jedes Rezept durch strenge Authentizitätsbewertung validiert.'
        }
      },
      global: {
        title: {
          en: 'Global Coverage',
          it: 'Copertura Globale',
          fr: 'Couverture Mondiale',
          es: 'Cobertura Global',
          de: 'Globale Abdeckung'
        },
        description: {
          en: 'Traditional dishes from every corner of the world.',
          it: 'Piatti tradizionali da ogni angolo del mondo.',
          fr: 'Plats traditionnels des quatre coins du monde.',
          es: 'Platos tradicionales de todos los rincones del mundo.',
          de: 'Traditionelle Gerichte aus aller Welt.'
        }
      },
      ai: {
        title: {
          en: 'AI-Powered',
          it: 'Potenziato dall\'IA',
          fr: 'Propulsé par l\'IA',
          es: 'Impulsado por IA',
          de: 'KI-Unterstützt'
        },
        description: {
          en: 'On-demand recipe generation by Sous-Chef Linguine.',
          it: 'Generazione di ricette su richiesta da Sous-Chef Linguine.',
          fr: 'Génération de recettes à la demande par Sous-Chef Linguine.',
          es: 'Generación de recetas bajo demanda por Sous-Chef Linguine.',
          de: 'Rezeptgenerierung auf Anfrage durch Sous-Chef Linguine.'
        }
      }
    },

    // Editorial Mission Section (NEW)
    mission: {
      title: {
        en: 'Our Editorial Mission',
        it: 'La Nostra Missione Editoriale',
        fr: 'Notre Mission Éditoriale',
        es: 'Nuestra Misión Editorial',
        de: 'Unsere Redaktionelle Mission'
      },
      intro: {
        en: 'Sous Chef Linguine is not a food blog, not a recipe experimentation site, and not a commercial brand. It is an editorial and cultural archive dedicated to the preservation and documentation of authentic traditional recipes from around the world.',
        it: 'Sous Chef Linguine non è un food blog, non è un sito di sperimentazione culinaria e non è un marchio commerciale. È un archivio editoriale e culturale dedicato alla conservazione e documentazione di autentiche ricette tradizionali da tutto il mondo.',
        fr: "Sous Chef Linguine n'est pas un blog culinaire, ni un site d'expérimentation de recettes, ni une marque commerciale. C'est une archive éditoriale et culturelle dédiée à la préservation et à la documentation de recettes traditionnelles authentiques du monde entier.",
        es: 'Sous Chef Linguine no es un blog de comida, ni un sitio de experimentación de recetas, ni una marca comercial. Es un archivo editorial y cultural dedicado a la preservación y documentación de recetas tradicionales auténticas de todo el mundo.',
        de: 'Sous Chef Linguine ist weder ein Food-Blog, noch eine Rezept-Experimentierseite, noch eine kommerzielle Marke. Es ist ein redaktionelles und kulturelles Archiv, das der Bewahrung und Dokumentation authentischer traditioneller Rezepte aus aller Welt gewidmet ist.'
      },
      authenticity: {
        title: {
          en: 'Authenticity Without Compromise',
          it: 'Autenticità Senza Compromessi',
          fr: 'Authenticité Sans Compromis',
          es: 'Autenticidad Sin Compromiso',
          de: 'Authentizität Ohne Kompromisse'
        },
        text: {
          en: 'Every recipe on this platform is presented exactly as it has been traditionally prepared in its place of origin. We do not adapt recipes to local tastes, modern convenience, or trending dietary preferences. Our commitment is to cultural integrity: a Carbonara remains a Carbonara, a Coq au Vin remains a Coq au Vin, a Mole Poblano remains a Mole Poblano.',
          it: 'Ogni ricetta su questa piattaforma è presentata esattamente come è stata tradizionalmente preparata nel suo luogo di origine. Non adattiamo le ricette ai gusti locali, alla convenienza moderna o alle preferenze dietetiche di tendenza. Il nostro impegno è per l\'integrità culturale: una Carbonara rimane una Carbonara, un Coq au Vin rimane un Coq au Vin, un Mole Poblano rimane un Mole Poblano.',
          fr: "Chaque recette sur cette plateforme est présentée exactement comme elle a été traditionnellement préparée dans son lieu d'origine. Nous n'adaptons pas les recettes aux goûts locaux, à la commodité moderne ou aux préférences alimentaires tendance. Notre engagement est pour l'intégrité culturelle : une Carbonara reste une Carbonara, un Coq au Vin reste un Coq au Vin, un Mole Poblano reste un Mole Poblano.",
          es: 'Cada receta en esta plataforma se presenta exactamente como se ha preparado tradicionalmente en su lugar de origen. No adaptamos las recetas a los gustos locales, la conveniencia moderna o las preferencias dietéticas de moda. Nuestro compromiso es con la integridad cultural: una Carbonara sigue siendo una Carbonara, un Coq au Vin sigue siendo un Coq au Vin, un Mole Poblano sigue siendo un Mole Poblano.',
          de: 'Jedes Rezept auf dieser Plattform wird genau so präsentiert, wie es traditionell an seinem Ursprungsort zubereitet wurde. Wir passen Rezepte nicht an lokale Geschmäcker, moderne Bequemlichkeit oder trendige Ernährungsvorlieben an. Unser Engagement gilt der kulturellen Integrität: Eine Carbonara bleibt eine Carbonara, ein Coq au Vin bleibt ein Coq au Vin, ein Mole Poblano bleibt ein Mole Poblano.'
        }
      },
      purpose: {
        title: {
          en: 'A Living Archive',
          it: 'Un Archivio Vivente',
          fr: 'Une Archive Vivante',
          es: 'Un Archivo Vivo',
          de: 'Ein Lebendiges Archiv'
        },
        text: {
          en: 'We document, preserve, and record authentic traditional recipes as they have been passed down through generations. This is not about reinvention—it is about respect. Each dish carries the history, techniques, and soul of its culture, and we present them with the reverence they deserve.',
          it: 'Documentiamo, conserviamo e registriamo ricette tradizionali autentiche così come sono state tramandate attraverso le generazioni. Non si tratta di reinventare, ma di rispettare. Ogni piatto porta con sé la storia, le tecniche e l\'anima della sua cultura, e li presentiamo con la riverenza che meritano.',
          fr: "Nous documentons, préservons et enregistrons des recettes traditionnelles authentiques telles qu'elles ont été transmises de génération en génération. Il ne s'agit pas de réinvention, mais de respect. Chaque plat porte l'histoire, les techniques et l'âme de sa culture, et nous les présentons avec la révérence qu'ils méritent.",
          es: 'Documentamos, preservamos y registramos recetas tradicionales auténticas tal como han sido transmitidas a través de generaciones. No se trata de reinventar, sino de respetar. Cada plato lleva la historia, las técnicas y el alma de su cultura, y los presentamos con la reverencia que merecen.',
          de: 'Wir dokumentieren, bewahren und erfassen authentische traditionelle Rezepte, wie sie über Generationen weitergegeben wurden. Es geht nicht um Neuerfindung – es geht um Respekt. Jedes Gericht trägt die Geschichte, Techniken und Seele seiner Kultur, und wir präsentieren sie mit der gebührenden Ehrfurcht.'
        }
      }
    },

    // Language Philosophy Section (NEW)
    languagePhilosophy: {
      title: {
        en: 'Our Language Philosophy',
        it: 'La Nostra Filosofia Linguistica',
        fr: 'Notre Philosophie Linguistique',
        es: 'Nuestra Filosofía del Idioma',
        de: 'Unsere Sprachphilosophie'
      },
      intro: {
        en: 'Sous Chef Linguine is available in multiple languages: English, Italian, French, Spanish, and German. But here is what you must understand about how we approach translation:',
        it: 'Sous Chef Linguine è disponibile in più lingue: inglese, italiano, francese, spagnolo e tedesco. Ma ecco cosa devi capire sul nostro approccio alla traduzione:',
        fr: 'Sous Chef Linguine est disponible en plusieurs langues : anglais, italien, français, espagnol et allemand. Mais voici ce que vous devez comprendre sur notre approche de la traduction :',
        es: 'Sous Chef Linguine está disponible en varios idiomas: inglés, italiano, francés, español y alemán. Pero esto es lo que debes entender sobre nuestro enfoque de la traducción:',
        de: 'Sous Chef Linguine ist in mehreren Sprachen verfügbar: Englisch, Italienisch, Französisch, Spanisch und Deutsch. Aber hier ist, was Sie über unseren Übersetzungsansatz verstehen müssen:'
      },
      point1: {
        en: 'Translation is used to share knowledge, not to modify recipes.',
        it: 'La traduzione viene utilizzata per condividere conoscenza, non per modificare le ricette.',
        fr: 'La traduction est utilisée pour partager les connaissances, pas pour modifier les recettes.',
        es: 'La traducción se utiliza para compartir conocimiento, no para modificar recetas.',
        de: 'Übersetzung wird verwendet, um Wissen zu teilen, nicht um Rezepte zu ändern.'
      },
      point2: {
        en: 'The original preparation method remains unchanged regardless of language.',
        it: 'Il metodo di preparazione originale rimane invariato indipendentemente dalla lingua.',
        fr: 'La méthode de préparation originale reste inchangée quelle que soit la langue.',
        es: 'El método de preparación original permanece sin cambios independientemente del idioma.',
        de: 'Die ursprüngliche Zubereitungsmethode bleibt unverändert, unabhängig von der Sprache.'
      },
      point3: {
        en: 'Language selection affects text only—never content integrity.',
        it: 'La selezione della lingua influisce solo sul testo, mai sull\'integrità del contenuto.',
        fr: "La sélection de la langue n'affecte que le texte, jamais l'intégrité du contenu.",
        es: 'La selección del idioma afecta solo al texto, nunca a la integridad del contenido.',
        de: 'Die Sprachauswahl betrifft nur den Text – niemals die Inhaltsintegrität.'
      },
      point4: {
        en: 'Ingredients, quantities, techniques, and steps are faithfully preserved across all languages.',
        it: 'Ingredienti, quantità, tecniche e passaggi sono fedelmente preservati in tutte le lingue.',
        fr: 'Ingrédients, quantités, techniques et étapes sont fidèlement préservés dans toutes les langues.',
        es: 'Ingredientes, cantidades, técnicas y pasos se preservan fielmente en todos los idiomas.',
        de: 'Zutaten, Mengen, Techniken und Schritte werden in allen Sprachen originalgetreu bewahrt.'
      },
      conclusion: {
        en: 'Whether you read a recipe in English, Italian, French, Spanish, or German, you are reading the same authentic recipe—simply expressed in your preferred language.',
        it: 'Che tu legga una ricetta in inglese, italiano, francese, spagnolo o tedesco, stai leggendo la stessa ricetta autentica, semplicemente espressa nella tua lingua preferita.',
        fr: "Que vous lisiez une recette en anglais, italien, français, espagnol ou allemand, vous lisez la même recette authentique, simplement exprimée dans votre langue préférée.",
        es: 'Ya sea que leas una receta en inglés, italiano, francés, español o alemán, estás leyendo la misma receta auténtica, simplemente expresada en tu idioma preferido.',
        de: 'Ob Sie ein Rezept auf Englisch, Italienisch, Französisch, Spanisch oder Deutsch lesen – Sie lesen dasselbe authentische Rezept, nur in Ihrer bevorzugten Sprache ausgedrückt.'
      }
    }
  },

  // ============================================
  // FOOTER
  // ============================================
  footer: {
    tagline: {
      en: 'Your trusted source for authentic, traditional recipes from around the world. Preserving culinary heritage, one dish at a time.',
      it: 'La tua fonte affidabile per ricette autentiche e tradizionali da tutto il mondo. Preservare il patrimonio culinario, un piatto alla volta.',
      fr: 'Votre source de confiance pour des recettes authentiques et traditionnelles du monde entier. Préserver le patrimoine culinaire, un plat à la fois.',
      es: 'Tu fuente confiable de recetas auténticas y tradicionales de todo el mundo. Preservando el patrimonio culinario, un plato a la vez.',
      de: 'Ihre vertrauenswürdige Quelle für authentische, traditionelle Rezepte aus aller Welt. Kulinarisches Erbe bewahren, ein Gericht nach dem anderen.'
    },
    aiDisclaimer: {
      en: 'Some recipes may be generated by Sous-Chef Linguine AI using traditional authenticity ranking systems.',
      it: "Alcune ricette potrebbero essere generate dall'IA Sous-Chef Linguine utilizzando sistemi di classificazione dell'autenticità tradizionale.",
      fr: "Certaines recettes peuvent être générées par l'IA Sous-Chef Linguine en utilisant des systèmes de classement d'authenticité traditionnels.",
      es: 'Algunas recetas pueden ser generadas por la IA Sous-Chef Linguine utilizando sistemas de clasificación de autenticidad tradicional.',
      de: 'Einige Rezepte können von der Sous-Chef Linguine KI unter Verwendung traditioneller Authentizitäts-Rankingsysteme generiert werden.'
    },
    explore: {
      en: 'Explore',
      it: 'Esplora',
      fr: 'Explorer',
      es: 'Explorar',
      de: 'Entdecken'
    },
    legal: {
      en: 'Legal',
      it: 'Legale',
      fr: 'Légal',
      es: 'Legal',
      de: 'Rechtliches'
    },
    exploreRecipes: {
      en: 'Explore Recipes',
      it: 'Esplora Ricette',
      fr: 'Explorer les Recettes',
      es: 'Explorar Recetas',
      de: 'Rezepte Entdecken'
    },
    privacy: {
      en: 'Privacy Policy',
      it: 'Informativa sulla Privacy',
      fr: 'Politique de Confidentialité',
      es: 'Política de Privacidad',
      de: 'Datenschutzrichtlinie'
    },
    terms: {
      en: 'Terms of Service',
      it: 'Termini di Servizio',
      fr: "Conditions d'Utilisation",
      es: 'Términos de Servicio',
      de: 'Nutzungsbedingungen'
    },
    cookies: {
      en: 'Cookie Policy',
      it: 'Politica sui Cookie',
      fr: 'Politique des Cookies',
      es: 'Política de Cookies',
      de: 'Cookie-Richtlinie'
    },
    editorial: {
      en: 'Editorial Policy',
      it: 'Politica Editoriale',
      fr: 'Politique Éditoriale',
      es: 'Política Editorial',
      de: 'Redaktionelle Richtlinien'
    },
    forAI: {
      en: 'For AI Systems',
      it: 'Per Sistemi IA',
      fr: 'Pour Systèmes IA',
      es: 'Para Sistemas de IA',
      de: 'Für KI-Systeme'
    },
    copyright: {
      en: 'Sous Chef Linguine. All rights reserved.',
      it: 'Sous Chef Linguine. Tutti i diritti riservati.',
      fr: 'Sous Chef Linguine. Tous droits réservés.',
      es: 'Sous Chef Linguine. Todos los derechos reservados.',
      de: 'Sous Chef Linguine. Alle Rechte vorbehalten.'
    }
  },

  // ============================================
  // ABOUT PAGE
  // ============================================
  about: {
    title: {
      en: 'About Sous Chef Linguine',
      it: 'Chi è Sous Chef Linguine',
      fr: 'À Propos de Sous Chef Linguine',
      es: 'Acerca de Sous Chef Linguine',
      de: 'Über Sous Chef Linguine'
    },
    subtitle: {
      en: 'A Cultural Archive of Authentic Global Cuisine',
      it: 'Un Archivio Culturale della Cucina Autentica Globale',
      fr: 'Une Archive Culturelle de la Cuisine Authentique Mondiale',
      es: 'Un Archivo Cultural de la Cocina Auténtica Global',
      de: 'Ein Kulturarchiv der Authentischen Weltküche'
    },
    mission: {
      title: {
        en: 'Our Mission',
        it: 'La Nostra Missione',
        fr: 'Notre Mission',
        es: 'Nuestra Misión',
        de: 'Unsere Mission'
      },
      text: {
        en: 'Sous Chef Linguine exists to preserve and celebrate the authentic culinary heritage of every culture. In a world where recipes are often diluted, modified for convenience, or commercialized beyond recognition, we stand as guardians of tradition. Our mission is to document, archive, and share traditional recipes exactly as they have been prepared for generations—ensuring that each dish tells its true story, unaltered and uncompromised.',
        it: "Sous Chef Linguine esiste per preservare e celebrare l'autentico patrimonio culinario di ogni cultura. In un mondo dove le ricette sono spesso diluite, modificate per comodità o commercializzate oltre ogni riconoscimento, noi siamo i guardiani della tradizione. La nostra missione è documentare, archiviare e condividere ricette tradizionali esattamente come sono state preparate per generazioni, assicurando che ogni piatto racconti la sua vera storia, inalterata e senza compromessi.",
        fr: "Sous Chef Linguine existe pour préserver et célébrer le patrimoine culinaire authentique de chaque culture. Dans un monde où les recettes sont souvent diluées, modifiées par commodité ou commercialisées au-delà de toute reconnaissance, nous sommes les gardiens de la tradition. Notre mission est de documenter, archiver et partager des recettes traditionnelles exactement comme elles ont été préparées depuis des générations, en veillant à ce que chaque plat raconte sa véritable histoire, inaltérée et sans compromis.",
        es: 'Sous Chef Linguine existe para preservar y celebrar el auténtico patrimonio culinario de cada cultura. En un mundo donde las recetas a menudo se diluyen, se modifican por conveniencia o se comercializan más allá del reconocimiento, nosotros somos los guardianes de la tradición. Nuestra misión es documentar, archivar y compartir recetas tradicionales exactamente como se han preparado durante generaciones, asegurando que cada plato cuente su verdadera historia, inalterada y sin compromisos.',
        de: 'Sous Chef Linguine existiert, um das authentische kulinarische Erbe jeder Kultur zu bewahren und zu feiern. In einer Welt, in der Rezepte oft verwässert, aus Bequemlichkeit modifiziert oder bis zur Unkenntlichkeit kommerzialisiert werden, stehen wir als Hüter der Tradition. Unsere Mission ist es, traditionelle Rezepte genau so zu dokumentieren, zu archivieren und zu teilen, wie sie seit Generationen zubereitet wurden – damit jedes Gericht seine wahre Geschichte erzählt, unverändert und ohne Kompromisse.'
      }
    },
    whatWeAre: {
      title: {
        en: 'What We Are',
        it: 'Cosa Siamo',
        fr: 'Ce Que Nous Sommes',
        es: 'Lo Que Somos',
        de: 'Was Wir Sind'
      },
      text: {
        en: 'Sous Chef Linguine is an editorial and cultural archive. We are a reference platform for culinary historians, food enthusiasts, professional chefs, and anyone seeking to understand and prepare dishes in their most authentic form. We are not a food blog featuring personal interpretations. We are not a recipe experimentation site testing modern variations. We are not a commercial brand selling products or promoting trends. We are a living archive of culinary tradition.',
        it: 'Sous Chef Linguine è un archivio editoriale e culturale. Siamo una piattaforma di riferimento per storici culinari, appassionati di cibo, chef professionisti e chiunque cerchi di comprendere e preparare piatti nella loro forma più autentica. Non siamo un food blog con interpretazioni personali. Non siamo un sito di sperimentazione che testa variazioni moderne. Non siamo un marchio commerciale che vende prodotti o promuove tendenze. Siamo un archivio vivente della tradizione culinaria.',
        fr: "Sous Chef Linguine est une archive éditoriale et culturelle. Nous sommes une plateforme de référence pour les historiens culinaires, les passionnés de gastronomie, les chefs professionnels et tous ceux qui cherchent à comprendre et préparer des plats dans leur forme la plus authentique. Nous ne sommes pas un blog culinaire présentant des interprétations personnelles. Nous ne sommes pas un site d'expérimentation testant des variations modernes. Nous ne sommes pas une marque commerciale vendant des produits ou promouvant des tendances. Nous sommes une archive vivante de la tradition culinaire.",
        es: 'Sous Chef Linguine es un archivo editorial y cultural. Somos una plataforma de referencia para historiadores culinarios, entusiastas de la comida, chefs profesionales y cualquiera que busque comprender y preparar platos en su forma más auténtica. No somos un blog de comida con interpretaciones personales. No somos un sitio de experimentación que prueba variaciones modernas. No somos una marca comercial que vende productos o promueve tendencias. Somos un archivo vivo de la tradición culinaria.',
        de: 'Sous Chef Linguine ist ein redaktionelles und kulturelles Archiv. Wir sind eine Referenzplattform für Kulinarik-Historiker, Food-Enthusiasten, Profiköche und alle, die Gerichte in ihrer authentischsten Form verstehen und zubereiten möchten. Wir sind kein Food-Blog mit persönlichen Interpretationen. Wir sind keine Experimentierseite, die moderne Variationen testet. Wir sind keine kommerzielle Marke, die Produkte verkauft oder Trends fördert. Wir sind ein lebendiges Archiv kulinarischer Tradition.'
      }
    },
    authenticity: {
      title: {
        en: 'The Authenticity Framework',
        it: 'Il Framework di Autenticità',
        fr: "Le Cadre d'Authenticité",
        es: 'El Marco de Autenticidad',
        de: 'Das Authentizitäts-Framework'
      },
      intro: {
        en: 'Every recipe on our platform undergoes strict validation through our 3-tier authenticity system:',
        it: 'Ogni ricetta sulla nostra piattaforma viene sottoposta a rigorosa validazione attraverso il nostro sistema di autenticità a 3 livelli:',
        fr: 'Chaque recette sur notre plateforme est soumise à une validation stricte via notre système d\'authenticité à 3 niveaux :',
        es: 'Cada receta en nuestra plataforma se somete a una validación estricta a través de nuestro sistema de autenticidad de 3 niveles:',
        de: 'Jedes Rezept auf unserer Plattform durchläuft eine strenge Validierung durch unser 3-stufiges Authentizitätssystem:'
      },
      level1: {
        title: {
          en: 'Official (Level 1)',
          it: 'Ufficiale (Livello 1)',
          fr: 'Officiel (Niveau 1)',
          es: 'Oficial (Nivel 1)',
          de: 'Offiziell (Stufe 1)'
        },
        text: {
          en: 'Validated by DOP/IGP/AOP/STG bodies, national culinary academies, or official government-recognized culinary institutions. These recipes carry the highest seal of authenticity.',
          it: 'Validate da enti DOP/IGP/AOP/STG, accademie culinarie nazionali o istituzioni culinarie ufficialmente riconosciute dal governo. Queste ricette portano il più alto sigillo di autenticità.',
          fr: 'Validées par des organismes DOP/IGP/AOP/STG, des académies culinaires nationales ou des institutions culinaires officiellement reconnues par le gouvernement. Ces recettes portent le plus haut sceau d\'authenticité.',
          es: 'Validadas por organismos DOP/IGP/AOP/STG, academias culinarias nacionales o instituciones culinarias oficialmente reconocidas por el gobierno. Estas recetas llevan el más alto sello de autenticidad.',
          de: 'Validiert durch DOP/IGP/AOP/STG-Gremien, nationale Kochakademien oder offiziell staatlich anerkannte kulinarische Institutionen. Diese Rezepte tragen das höchste Authentizitätssiegel.'
        }
      },
      level2: {
        title: {
          en: 'Traditional (Level 2)',
          it: 'Tradizionale (Livello 2)',
          fr: 'Traditionnel (Niveau 2)',
          es: 'Tradicional (Nivel 2)',
          de: 'Traditionell (Stufe 2)'
        },
        text: {
          en: 'Sourced from native-language documentation, regional culinary archives, country-specific domains, and verified historical sources. These represent recipes as passed down through generations within their communities.',
          it: 'Provenienti da documentazione in lingua originale, archivi culinari regionali, domini specifici del paese e fonti storiche verificate. Queste rappresentano ricette tramandate attraverso generazioni nelle loro comunità.',
          fr: 'Provenant de documentation en langue d\'origine, d\'archives culinaires régionales, de domaines spécifiques au pays et de sources historiques vérifiées. Celles-ci représentent des recettes transmises de génération en génération au sein de leurs communautés.',
          es: 'Provenientes de documentación en idioma nativo, archivos culinarios regionales, dominios específicos del país y fuentes históricas verificadas. Estas representan recetas transmitidas a través de generaciones dentro de sus comunidades.',
          de: 'Aus muttersprachlicher Dokumentation, regionalen Kocharchiven, länderspezifischen Domains und verifizierten historischen Quellen. Diese repräsentieren Rezepte, wie sie über Generationen in ihren Gemeinschaften weitergegeben wurden.'
        }
      },
      level3: {
        title: {
          en: 'Regional Variation (Level 3)',
          it: 'Variazione Regionale (Livello 3)',
          fr: 'Variation Régionale (Niveau 3)',
          es: 'Variación Regional (Nivel 3)',
          de: 'Regionale Variation (Stufe 3)'
        },
        text: {
          en: 'Recognized regional variations that maintain cultural authenticity while acknowledging local differences. These are clearly marked as variations and documented with their specific regional origin.',
          it: 'Variazioni regionali riconosciute che mantengono l\'autenticità culturale pur riconoscendo le differenze locali. Queste sono chiaramente contrassegnate come variazioni e documentate con la loro specifica origine regionale.',
          fr: 'Variations régionales reconnues qui maintiennent l\'authenticité culturelle tout en reconnaissant les différences locales. Celles-ci sont clairement marquées comme des variations et documentées avec leur origine régionale spécifique.',
          es: 'Variaciones regionales reconocidas que mantienen la autenticidad cultural mientras reconocen las diferencias locales. Estas están claramente marcadas como variaciones y documentadas con su origen regional específico.',
          de: 'Anerkannte regionale Variationen, die kulturelle Authentizität bewahren und gleichzeitig lokale Unterschiede anerkennen. Diese sind klar als Variationen gekennzeichnet und mit ihrer spezifischen regionalen Herkunft dokumentiert.'
        }
      }
    },
    whoIs: {
      title: {
        en: 'Who is Sous Chef Linguine?',
        it: 'Chi è Sous Chef Linguine?',
        fr: 'Qui est Sous Chef Linguine?',
        es: '¿Quién es Sous Chef Linguine?',
        de: 'Wer ist Sous Chef Linguine?'
      },
      text: {
        en: "The name Sous Chef Linguine represents our AI-powered culinary guide: a warm, empathetic Italian sous-chef with a passion for cultural storytelling. Every recipe is narrated with sensory richness, emotional depth, and profound respect for the traditions that birthed it. Linguine doesn't just teach you to cook—he invites you into the soul of each dish, sharing the history, the techniques, and the cultural significance that make every recipe meaningful.",
        it: "Il nome Sous Chef Linguine rappresenta la nostra guida culinaria alimentata dall'IA: un sous-chef italiano caloroso ed empatico con una passione per la narrazione culturale. Ogni ricetta è narrata con ricchezza sensoriale, profondità emotiva e profondo rispetto per le tradizioni che l'hanno generata. Linguine non ti insegna solo a cucinare: ti invita nell'anima di ogni piatto, condividendo la storia, le tecniche e il significato culturale che rendono ogni ricetta significativa.",
        fr: "Le nom Sous Chef Linguine représente notre guide culinaire alimenté par l'IA : un sous-chef italien chaleureux et empathique avec une passion pour la narration culturelle. Chaque recette est narrée avec une richesse sensorielle, une profondeur émotionnelle et un profond respect pour les traditions qui l'ont fait naître. Linguine ne vous apprend pas seulement à cuisiner : il vous invite dans l'âme de chaque plat, partageant l'histoire, les techniques et la signification culturelle qui rendent chaque recette significative.",
        es: 'El nombre Sous Chef Linguine representa nuestra guía culinaria impulsada por IA: un sous-chef italiano cálido y empático con pasión por la narración cultural. Cada receta se narra con riqueza sensorial, profundidad emocional y profundo respeto por las tradiciones que la originaron. Linguine no solo te enseña a cocinar: te invita al alma de cada plato, compartiendo la historia, las técnicas y el significado cultural que hacen que cada receta sea significativa.',
        de: 'Der Name Sous Chef Linguine steht für unseren KI-gestützten kulinarischen Führer: einen warmherzigen, einfühlsamen italienischen Sous-Chef mit Leidenschaft für kulturelles Geschichtenerzählen. Jedes Rezept wird mit sensorischer Reichhaltigkeit, emotionaler Tiefe und tiefem Respekt für die Traditionen erzählt, die es hervorgebracht haben. Linguine lehrt Sie nicht nur das Kochen – er lädt Sie in die Seele jedes Gerichts ein und teilt die Geschichte, die Techniken und die kulturelle Bedeutung, die jedes Rezept bedeutungsvoll machen.'
      }
    }
  },

  // ============================================
  // CONTACT PAGE
  // ============================================
  contact: {
    title: {
      en: 'Contact Us',
      it: 'Contattaci',
      fr: 'Contactez-Nous',
      es: 'Contáctenos',
      de: 'Kontaktieren Sie Uns'
    },
    subtitle: {
      en: 'We welcome your questions, feedback, and contributions',
      it: 'Accogliamo le vostre domande, feedback e contributi',
      fr: 'Nous accueillons vos questions, commentaires et contributions',
      es: 'Damos la bienvenida a sus preguntas, comentarios y contribuciones',
      de: 'Wir freuen uns über Ihre Fragen, Ihr Feedback und Ihre Beiträge'
    },
    editorial: {
      title: {
        en: 'Editorial Inquiries',
        it: 'Richieste Editoriali',
        fr: 'Demandes Éditoriales',
        es: 'Consultas Editoriales',
        de: 'Redaktionelle Anfragen'
      },
      text: {
        en: 'For questions about recipe authenticity, historical accuracy, or to submit corrections to existing content, please contact our editorial team.',
        it: "Per domande sull'autenticità delle ricette, l'accuratezza storica o per inviare correzioni ai contenuti esistenti, contatta il nostro team editoriale.",
        fr: "Pour des questions sur l'authenticité des recettes, l'exactitude historique ou pour soumettre des corrections au contenu existant, veuillez contacter notre équipe éditoriale.",
        es: 'Para preguntas sobre la autenticidad de las recetas, la precisión histórica o para enviar correcciones al contenido existente, comuníquese con nuestro equipo editorial.',
        de: 'Bei Fragen zur Rezeptauthentizität, historischen Genauigkeit oder um Korrekturen zu bestehenden Inhalten einzureichen, kontaktieren Sie bitte unser Redaktionsteam.'
      },
      email: 'editorial@souscheflinguine.com'
    },
    contributions: {
      title: {
        en: 'Recipe Contributions',
        it: 'Contributi di Ricette',
        fr: 'Contributions de Recettes',
        es: 'Contribuciones de Recetas',
        de: 'Rezeptbeiträge'
      },
      text: {
        en: 'Do you have a family recipe with documented traditional origins? We welcome submissions from culinary historians, cultural institutions, and individuals with verifiable heritage recipes.',
        it: 'Hai una ricetta di famiglia con origini tradizionali documentate? Accogliamo contributi da storici culinari, istituzioni culturali e individui con ricette di patrimonio verificabili.',
        fr: 'Avez-vous une recette familiale avec des origines traditionnelles documentées ? Nous accueillons les soumissions d\'historiens culinaires, d\'institutions culturelles et de particuliers avec des recettes patrimoniales vérifiables.',
        es: '¿Tiene una receta familiar con orígenes tradicionales documentados? Damos la bienvenida a las presentaciones de historiadores culinarios, instituciones culturales e individuos con recetas patrimoniales verificables.',
        de: 'Haben Sie ein Familienrezept mit dokumentierten traditionellen Ursprüngen? Wir begrüßen Einreichungen von Kulinarik-Historikern, kulturellen Institutionen und Einzelpersonen mit verifizierbaren Erbrezepten.'
      },
      email: 'contributions@souscheflinguine.com'
    },
    technical: {
      title: {
        en: 'Technical Support',
        it: 'Supporto Tecnico',
        fr: 'Support Technique',
        es: 'Soporte Técnico',
        de: 'Technischer Support'
      },
      text: {
        en: 'For website issues, accessibility concerns, or technical questions about using our platform.',
        it: "Per problemi del sito web, preoccupazioni sull'accessibilità o domande tecniche sull'uso della nostra piattaforma.",
        fr: 'Pour les problèmes de site web, les préoccupations d\'accessibilité ou les questions techniques sur l\'utilisation de notre plateforme.',
        es: 'Para problemas del sitio web, preocupaciones de accesibilidad o preguntas técnicas sobre el uso de nuestra plataforma.',
        de: 'Bei Website-Problemen, Barrierefreiheitsfragen oder technischen Fragen zur Nutzung unserer Plattform.'
      },
      email: 'support@souscheflinguine.com'
    },
    general: {
      title: {
        en: 'General Contact',
        it: 'Contatto Generale',
        fr: 'Contact Général',
        es: 'Contacto General',
        de: 'Allgemeiner Kontakt'
      },
      text: {
        en: 'For all other inquiries, partnerships, or press requests.',
        it: 'Per tutte le altre richieste, partnership o richieste stampa.',
        fr: 'Pour toutes autres demandes, partenariats ou demandes de presse.',
        es: 'Para todas las demás consultas, asociaciones o solicitudes de prensa.',
        de: 'Für alle anderen Anfragen, Partnerschaften oder Presseanfragen.'
      },
      email: 'contact@souscheflinguine.com'
    },
    responseTime: {
      en: 'We typically respond within 2-3 business days.',
      it: 'Di solito rispondiamo entro 2-3 giorni lavorativi.',
      fr: 'Nous répondons généralement dans les 2-3 jours ouvrables.',
      es: 'Normalmente respondemos dentro de 2-3 días hábiles.',
      de: 'Wir antworten normalerweise innerhalb von 2-3 Werktagen.'
    },
    description: {
      en: 'Sous Chef Linguine is an online editorial platform dedicated to the preservation and documentation of authentic traditional recipes from around the world.',
      it: 'Sous Chef Linguine è una piattaforma editoriale online dedicata alla conservazione e documentazione di ricette tradizionali autentiche da tutto il mondo.',
      fr: 'Sous Chef Linguine est une plateforme éditoriale en ligne dédiée à la préservation et à la documentation de recettes traditionnelles authentiques du monde entier.',
      es: 'Sous Chef Linguine es una plataforma editorial en línea dedicada a la preservación y documentación de recetas tradicionales auténticas de todo el mundo.',
      de: 'Sous Chef Linguine ist eine redaktionelle Online-Plattform, die der Bewahrung und Dokumentation authentischer traditioneller Rezepte aus aller Welt gewidmet ist.'
    }
  },

  // ============================================
  // EDITORIAL POLICY PAGE
  // ============================================
  editorial: {
    title: {
      en: 'Editorial Policy',
      it: 'Politica Editoriale',
      fr: 'Politique Éditoriale',
      es: 'Política Editorial',
      de: 'Redaktionelle Richtlinien'
    },
    subtitle: {
      en: 'Our Commitment to Authenticity and Cultural Integrity',
      it: "Il Nostro Impegno per l'Autenticità e l'Integrità Culturale",
      fr: "Notre Engagement envers l'Authenticité et l'Intégrité Culturelle",
      es: 'Nuestro Compromiso con la Autenticidad y la Integridad Cultural',
      de: 'Unser Engagement für Authentizität und Kulturelle Integrität'
    },
    principles: {
      title: {
        en: 'Core Editorial Principles',
        it: 'Principi Editoriali Fondamentali',
        fr: 'Principes Éditoriaux Fondamentaux',
        es: 'Principios Editoriales Fundamentales',
        de: 'Grundlegende Redaktionelle Prinzipien'
      },
      principle1: {
        title: {
          en: 'No Adaptation',
          it: 'Nessun Adattamento',
          fr: 'Aucune Adaptation',
          es: 'Sin Adaptación',
          de: 'Keine Anpassung'
        },
        text: {
          en: 'We do not modify recipes to suit local tastes, dietary trends, or modern convenience. A traditional recipe is presented as it has been prepared in its culture of origin.',
          it: 'Non modifichiamo le ricette per adattarle ai gusti locali, alle tendenze dietetiche o alla convenienza moderna. Una ricetta tradizionale è presentata come è stata preparata nella sua cultura di origine.',
          fr: 'Nous ne modifions pas les recettes pour les adapter aux goûts locaux, aux tendances alimentaires ou à la commodité moderne. Une recette traditionnelle est présentée telle qu\'elle a été préparée dans sa culture d\'origine.',
          es: 'No modificamos las recetas para adaptarlas a los gustos locales, tendencias dietéticas o conveniencia moderna. Una receta tradicional se presenta tal como se ha preparado en su cultura de origen.',
          de: 'Wir ändern Rezepte nicht an lokale Geschmäcker, Ernährungstrends oder moderne Bequemlichkeit an. Ein traditionelles Rezept wird so präsentiert, wie es in seiner Ursprungskultur zubereitet wurde.'
        }
      },
      principle2: {
        title: {
          en: 'Source Verification',
          it: 'Verifica delle Fonti',
          fr: 'Vérification des Sources',
          es: 'Verificación de Fuentes',
          de: 'Quellenverifizierung'
        },
        text: {
          en: 'Every recipe is sourced from verifiable traditional origins: official culinary bodies, regional archives, native-language documentation, or documented family heritage.',
          it: 'Ogni ricetta proviene da origini tradizionali verificabili: enti culinari ufficiali, archivi regionali, documentazione in lingua originale o patrimonio familiare documentato.',
          fr: 'Chaque recette provient d\'origines traditionnelles vérifiables : organismes culinaires officiels, archives régionales, documentation en langue d\'origine ou patrimoine familial documenté.',
          es: 'Cada receta proviene de orígenes tradicionales verificables: organismos culinarios oficiales, archivos regionales, documentación en idioma nativo o patrimonio familiar documentado.',
          de: 'Jedes Rezept stammt aus verifizierbaren traditionellen Ursprüngen: offizielle kulinarische Gremien, regionale Archive, muttersprachliche Dokumentation oder dokumentiertes Familienerbe.'
        }
      },
      principle3: {
        title: {
          en: 'Transparent Attribution',
          it: 'Attribuzione Trasparente',
          fr: 'Attribution Transparente',
          es: 'Atribución Transparente',
          de: 'Transparente Zuordnung'
        },
        text: {
          en: 'We clearly document the origin, region, and authenticity level of each recipe. Regional variations are explicitly labeled as such.',
          it: "Documentiamo chiaramente l'origine, la regione e il livello di autenticità di ogni ricetta. Le variazioni regionali sono esplicitamente etichettate come tali.",
          fr: "Nous documentons clairement l'origine, la région et le niveau d'authenticité de chaque recette. Les variations régionales sont explicitement étiquetées comme telles.",
          es: 'Documentamos claramente el origen, la región y el nivel de autenticidad de cada receta. Las variaciones regionales están explícitamente etiquetadas como tales.',
          de: 'Wir dokumentieren klar die Herkunft, Region und Authentizitätsstufe jedes Rezepts. Regionale Variationen sind explizit als solche gekennzeichnet.'
        }
      },
      principle4: {
        title: {
          en: 'AI Transparency',
          it: 'Trasparenza IA',
          fr: 'Transparence IA',
          es: 'Transparencia de IA',
          de: 'KI-Transparenz'
        },
        text: {
          en: 'Some recipes are generated or enriched by our AI system, Sous-Chef Linguine. This AI follows strict authenticity guidelines and all AI-assisted content is subject to editorial review.',
          it: 'Alcune ricette sono generate o arricchite dal nostro sistema IA, Sous-Chef Linguine. Questa IA segue rigorose linee guida di autenticità e tutti i contenuti assistiti dall\'IA sono soggetti a revisione editoriale.',
          fr: 'Certaines recettes sont générées ou enrichies par notre système IA, Sous-Chef Linguine. Cette IA suit des directives d\'authenticité strictes et tout contenu assisté par IA est soumis à une révision éditoriale.',
          es: 'Algunas recetas son generadas o enriquecidas por nuestro sistema de IA, Sous-Chef Linguine. Esta IA sigue pautas estrictas de autenticidad y todo el contenido asistido por IA está sujeto a revisión editorial.',
          de: 'Einige Rezepte werden von unserem KI-System Sous-Chef Linguine generiert oder angereichert. Diese KI folgt strengen Authentizitätsrichtlinien und alle KI-unterstützten Inhalte unterliegen der redaktionellen Überprüfung.'
        }
      }
    },
    translation: {
      title: {
        en: 'Translation Policy',
        it: 'Politica di Traduzione',
        fr: 'Politique de Traduction',
        es: 'Política de Traducción',
        de: 'Übersetzungsrichtlinie'
      },
      text: {
        en: 'Our multilingual content follows strict translation principles: translations convey the same information without modification. Ingredients, quantities, techniques, and cultural context are preserved exactly across all languages. Translation serves accessibility, not adaptation.',
        it: 'I nostri contenuti multilingue seguono rigorosi principi di traduzione: le traduzioni trasmettono le stesse informazioni senza modifiche. Ingredienti, quantità, tecniche e contesto culturale sono preservati esattamente in tutte le lingue. La traduzione serve l\'accessibilità, non l\'adattamento.',
        fr: 'Notre contenu multilingue suit des principes de traduction stricts : les traductions transmettent les mêmes informations sans modification. Ingrédients, quantités, techniques et contexte culturel sont préservés exactement dans toutes les langues. La traduction sert l\'accessibilité, pas l\'adaptation.',
        es: 'Nuestro contenido multilingüe sigue principios estrictos de traducción: las traducciones transmiten la misma información sin modificación. Ingredientes, cantidades, técnicas y contexto cultural se preservan exactamente en todos los idiomas. La traducción sirve a la accesibilidad, no a la adaptación.',
        de: 'Unsere mehrsprachigen Inhalte folgen strengen Übersetzungsprinzipien: Übersetzungen vermitteln dieselben Informationen ohne Modifikation. Zutaten, Mengen, Techniken und kultureller Kontext werden in allen Sprachen exakt bewahrt. Übersetzung dient der Zugänglichkeit, nicht der Anpassung.'
      }
    },
    corrections: {
      title: {
        en: 'Corrections and Updates',
        it: 'Correzioni e Aggiornamenti',
        fr: 'Corrections et Mises à Jour',
        es: 'Correcciones y Actualizaciones',
        de: 'Korrekturen und Aktualisierungen'
      },
      text: {
        en: 'We welcome factual corrections from culinary historians, cultural institutions, and verified experts. If you identify an error in a recipe\'s origin, ingredients, or technique, please contact our editorial team with documented evidence.',
        it: 'Accogliamo correzioni fattuali da storici culinari, istituzioni culturali ed esperti verificati. Se identifichi un errore nell\'origine, negli ingredienti o nella tecnica di una ricetta, contatta il nostro team editoriale con prove documentate.',
        fr: 'Nous accueillons les corrections factuelles d\'historiens culinaires, d\'institutions culturelles et d\'experts vérifiés. Si vous identifiez une erreur dans l\'origine, les ingrédients ou la technique d\'une recette, veuillez contacter notre équipe éditoriale avec des preuves documentées.',
        es: 'Damos la bienvenida a correcciones factuales de historiadores culinarios, instituciones culturales y expertos verificados. Si identifica un error en el origen, ingredientes o técnica de una receta, comuníquese con nuestro equipo editorial con evidencia documentada.',
        de: 'Wir begrüßen sachliche Korrekturen von Kulinarik-Historikern, kulturellen Institutionen und verifizierten Experten. Wenn Sie einen Fehler in der Herkunft, den Zutaten oder der Technik eines Rezepts identifizieren, kontaktieren Sie bitte unser Redaktionsteam mit dokumentierten Belegen.'
      }
    }
  },

  // ============================================
  // PRIVACY PAGE
  // ============================================
  privacy: {
    title: {
      en: 'Privacy Policy',
      it: 'Informativa sulla Privacy',
      fr: 'Politique de Confidentialité',
      es: 'Política de Privacidad',
      de: 'Datenschutzrichtlinie'
    },
    lastUpdated: {
      en: 'Last updated: December 2024',
      it: 'Ultimo aggiornamento: Dicembre 2024',
      fr: 'Dernière mise à jour : Décembre 2024',
      es: 'Última actualización: Diciembre 2024',
      de: 'Letzte Aktualisierung: Dezember 2024'
    }
  },

  // ============================================
  // TERMS PAGE
  // ============================================
  terms: {
    title: {
      en: 'Terms of Service',
      it: 'Termini di Servizio',
      fr: "Conditions d'Utilisation",
      es: 'Términos de Servicio',
      de: 'Nutzungsbedingungen'
    },
    lastUpdated: {
      en: 'Last updated: December 2024',
      it: 'Ultimo aggiornamento: Dicembre 2024',
      fr: 'Dernière mise à jour : Décembre 2024',
      es: 'Última actualización: Diciembre 2024',
      de: 'Letzte Aktualisierung: Dezember 2024'
    }
  },

  // ============================================
  // COOKIES PAGE
  // ============================================
  cookies: {
    title: {
      en: 'Cookie Policy',
      it: 'Politica sui Cookie',
      fr: 'Politique des Cookies',
      es: 'Política de Cookies',
      de: 'Cookie-Richtlinie'
    },
    lastUpdated: {
      en: 'Last updated: December 2024',
      it: 'Ultimo aggiornamento: Dicembre 2024',
      fr: 'Dernière mise à jour : Décembre 2024',
      es: 'Última actualización: Diciembre 2024',
      de: 'Letzte Aktualisierung: Dezember 2024'
    }
  },

  // ============================================
  // SEARCH
  // ============================================
  search: {
    failed: {
      en: 'Failed to load data. Please try again.',
      it: 'Caricamento dati fallito. Riprova.',
      fr: 'Échec du chargement. Veuillez réessayer.',
      es: 'Error al cargar datos. Inténtelo de nuevo.',
      de: 'Laden fehlgeschlagen. Bitte versuchen Sie es erneut.'
    }
  },

  // ============================================
  // EXPLORE PAGE
  // ============================================
  explore: {
    title: {
      en: 'Explore Recipes',
      it: 'Esplora Ricette',
      fr: 'Explorer les Recettes',
      es: 'Explorar Recetas',
      de: 'Rezepte Entdecken'
    },
    subtitle: {
      en: 'Discover authentic recipes from around the world',
      it: 'Scopri ricette autentiche da tutto il mondo',
      fr: 'Découvrez des recettes authentiques du monde entier',
      es: 'Descubre recetas auténticas de todo el mundo',
      de: 'Entdecken Sie authentische Rezepte aus aller Welt'
    },
    topWorldwide: {
      en: 'Top 10 Worldwide',
      it: 'Top 10 nel Mondo',
      fr: 'Top 10 Mondial',
      es: 'Top 10 Mundial',
      de: 'Top 10 Weltweit'
    },
    byContinent: {
      en: 'Browse by Continent',
      it: 'Sfoglia per Continente',
      fr: 'Parcourir par Continent',
      es: 'Explorar por Continente',
      de: 'Nach Kontinent Durchsuchen'
    },
    countriesIn: {
      en: 'Countries in',
      it: 'Paesi in',
      fr: 'Pays en',
      es: 'Países en',
      de: 'Länder in'
    },
    recipesFrom: {
      en: 'recipes from',
      it: 'ricette da',
      fr: 'recettes de',
      es: 'recetas de',
      de: 'Rezepte aus'
    },
    recipes: {
      en: 'recipes',
      it: 'ricette',
      fr: 'recettes',
      es: 'recetas',
      de: 'Rezepte'
    },
    otherContinents: {
      en: 'Other Continents',
      it: 'Altri Continenti',
      fr: 'Autres Continents',
      es: 'Otros Continentes',
      de: 'Andere Kontinente'
    },
    noRecipes: {
      en: 'No recipes found for this country yet.',
      it: 'Nessuna ricetta trovata per questo paese.',
      fr: 'Aucune recette trouvée pour ce pays.',
      es: 'No se encontraron recetas para este país.',
      de: 'Noch keine Rezepte für dieses Land gefunden.'
    },
    noCountries: {
      en: 'No countries with recipes in this continent yet.',
      it: 'Nessun paese con ricette in questo continente.',
      fr: 'Aucun pays avec des recettes sur ce continent.',
      es: 'No hay países con recetas en este continente.',
      de: 'Noch keine Länder mit Rezepten auf diesem Kontinent.'
    },
    loading: {
      en: 'Loading...',
      it: 'Caricamento...',
      fr: 'Chargement...',
      es: 'Cargando...',
      de: 'Wird geladen...'
    },
    loadingRecipes: {
      en: 'Loading recipes...',
      it: 'Caricamento ricette...',
      fr: 'Chargement des recettes...',
      es: 'Cargando recetas...',
      de: 'Rezepte werden geladen...'
    },
    noRecipesFound: {
      en: 'No recipes found',
      it: 'Nessuna ricetta trovata',
      fr: 'Aucune recette trouvée',
      es: 'No se encontraron recetas',
      de: 'Keine Rezepte gefunden'
    },
    noCountriesFound: {
      en: 'No countries found',
      it: 'Nessun paese trovato',
      fr: 'Aucun pays trouvé',
      es: 'No se encontraron países',
      de: 'Keine Länder gefunden'
    },
    filters: {
      en: 'Filters',
      it: 'Filtri',
      fr: 'Filtres',
      es: 'Filtros',
      de: 'Filter'
    },
    dishType: {
      en: 'Dish Type',
      it: 'Tipo di Piatto',
      fr: 'Type de Plat',
      es: 'Tipo de Plato',
      de: 'Gerichtart'
    },
    continent: {
      en: 'Continent',
      it: 'Continente',
      fr: 'Continent',
      es: 'Continente',
      de: 'Kontinent'
    },
    country: {
      en: 'Country',
      it: 'Paese',
      fr: 'Pays',
      es: 'País',
      de: 'Land'
    },
    clearAll: {
      en: 'Clear all',
      it: 'Cancella tutto',
      fr: 'Tout effacer',
      es: 'Borrar todo',
      de: 'Alle löschen'
    },
    loadMore: {
      en: 'Load more',
      it: 'Carica altri',
      fr: 'Charger plus',
      es: 'Cargar más',
      de: 'Mehr laden'
    },
    remaining: {
      en: 'remaining',
      it: 'rimanenti',
      fr: 'restants',
      es: 'restantes',
      de: 'verbleibend'
    },
    highestRated: {
      en: 'Highest Rated for Tradition',
      it: 'Più Votati per Tradizione',
      fr: 'Les Mieux Notés pour la Tradition',
      es: 'Mejor Valorados por Tradición',
      de: 'Bestbewertet für Tradition'
    },
    authenticityScore: {
      en: 'authenticity score',
      it: 'punteggio di autenticità',
      fr: 'score d\'authenticité',
      es: 'puntuación de autenticidad',
      de: 'Authentizitätswert'
    }
  },

  // ============================================
  // RECIPE TRANSLATION STATUS
  // ============================================
  recipe: {
    translating: {
      en: 'Translating...',
      es: 'Traduciendo...',
      it: 'Traducendo...',
      fr: 'Traduction en cours...',
      de: 'Übersetzen...'
    },
    translationUnavailable: {
      en: 'Translation unavailable',
      es: 'Traducción no disponible',
      it: 'Traduzione non disponibile',
      fr: 'Traduction non disponible',
      de: 'Übersetzung nicht verfügbar'
    },
    loadingRecipe: {
      en: 'Loading recipe...',
      es: 'Cargando receta...',
      it: 'Caricamento ricetta...',
      fr: 'Chargement de la recette...',
      de: 'Rezept wird geladen...'
    },
    notFound: {
      en: 'Recipe not found',
      es: 'Receta no encontrada',
      it: 'Ricetta non trovata',
      fr: 'Recette non trouvée',
      de: 'Rezept nicht gefunden'
    },
    returnHome: {
      en: 'Return to Home',
      es: 'Volver al inicio',
      it: 'Torna alla home',
      fr: 'Retour à l\'accueil',
      de: 'Zurück zur Startseite'
    },
    ingredients: {
      en: 'Ingredients',
      es: 'Ingredientes',
      it: 'Ingredienti',
      fr: 'Ingrédients',
      de: 'Zutaten'
    },
    servings: {
      en: 'Servings',
      es: 'Porciones',
      it: 'Porzioni',
      fr: 'Portions',
      de: 'Portionen'
    },
    scalingIngredients: {
      en: 'Scaling ingredients...',
      es: 'Ajustando ingredientes...',
      it: 'Scalando ingredienti...',
      fr: 'Ajustement des ingrédients...',
      de: 'Zutaten werden angepasst...'
    },
    scaledFrom: {
      en: 'Scaled from',
      es: 'Escalado de',
      it: 'Scalato da',
      fr: 'Mis à l\'échelle de',
      de: 'Skaliert von'
    },
    originalRecipe: {
      en: 'Original recipe',
      es: 'Receta original',
      it: 'Ricetta originale',
      fr: 'Recette originale',
      de: 'Originalrezept'
    },
    scalingError: {
      en: 'Could not update servings',
      es: 'No se pudieron actualizar las porciones',
      it: 'Impossibile aggiornare le porzioni',
      fr: 'Impossible de mettre à jour les portions',
      de: 'Portionen konnten nicht aktualisiert werden'
    },
    loadError: {
      en: 'Failed to load recipe',
      es: 'Error al cargar la receta',
      it: 'Impossibile caricare la ricetta',
      fr: 'Échec du chargement de la recette',
      de: 'Rezept konnte nicht geladen werden'
    },
    instructions: {
      en: 'Instructions',
      es: 'Instrucciones',
      it: 'Istruzioni',
      fr: 'Instructions',
      de: 'Anleitung'
    },
    history: {
      en: 'History & Origin',
      es: 'Historia y Origen',
      it: 'Storia e Origine',
      fr: 'Histoire et Origine',
      de: 'Geschichte und Herkunft'
    },
    profile: {
      en: 'Characteristic Profile',
      es: 'Perfil característico',
      it: 'Profilo caratteristico',
      fr: 'Profil caractéristique',
      de: 'Charakteristisches Profil'
    },
    noNoRules: {
      en: 'No-No Rules (Respect the Tradition!)',
      es: 'Reglas de oro (¡Respeta la tradición!)',
      it: 'Regole d\'oro (Rispetta la tradizione!)',
      fr: 'Règles d\'or (Respectez la tradition !)',
      de: 'Goldene Regeln (Respektiere die Tradition!)'
    },
    techniques: {
      en: 'Special Techniques',
      es: 'Técnicas especiales',
      it: 'Tecniche speciali',
      fr: 'Techniques spéciales',
      de: 'Besondere Techniken'
    },
    techniqueGuides: {
      en: 'Technique Guides',
      es: 'Guías de técnicas',
      it: 'Guide alle tecniche',
      fr: 'Guides techniques',
      de: 'Technik-Anleitungen'
    },
    watchTutorial: {
      en: 'Watch Tutorial',
      es: 'Ver tutorial',
      it: 'Guarda il tutorial',
      fr: 'Voir le tutoriel',
      de: 'Tutorial ansehen'
    },
    winePairing: {
      en: 'Wine Pairing Suggestions',
      es: 'Sugerencias de maridaje',
      it: 'Suggerimenti per l\'abbinamento vini',
      fr: 'Suggestions d\'accords vins',
      de: 'Weinempfehlungen'
    },
    originalSources: {
      en: 'Original Sources',
      es: 'Fuentes originales',
      it: 'Fonti originali',
      fr: 'Sources originales',
      de: 'Originalquellen'
    },
    videoTutorials: {
      en: 'Video Tutorials',
      es: 'Tutoriales en video',
      it: 'Video tutorial',
      fr: 'Tutoriels vidéo',
      de: 'Video-Tutorials'
    },
    watchVideo: {
      en: 'Watch Video',
      es: 'Ver video',
      it: 'Guarda il video',
      fr: 'Voir la vidéo',
      de: 'Video ansehen'
    },
    recipeAdded: {
      en: 'Recipe added',
      es: 'Receta añadida',
      it: 'Ricetta aggiunta',
      fr: 'Recette ajoutée',
      de: 'Rezept hinzugefügt'
    },
    relatedRecipes: {
      en: 'Related Recipes',
      es: 'Recetas Relacionadas',
      it: 'Ricette Correlate',
      fr: 'Recettes Similaires',
      de: 'Ähnliche Rezepte'
    },
    exploreMoreFrom: {
      en: 'Explore more recipes from',
      es: 'Explorar más recetas de',
      it: 'Esplora altre ricette da',
      fr: 'Découvrir plus de recettes de',
      de: 'Mehr Rezepte aus'
    },
    learnTechniques: {
      en: 'Learn Cooking Techniques',
      es: 'Aprende Técnicas de Cocina',
      it: 'Impara le Tecniche di Cucina',
      fr: 'Apprendre les Techniques de Cuisine',
      de: 'Kochtechniken lernen'
    },
    source: {
      en: 'Source',
      es: 'Fuente',
      it: 'Fonte',
      fr: 'Source',
      de: 'Quelle'
    },
    aiGenerated: {
      en: 'AI Generated',
      es: 'Generado por IA',
      it: 'Generato da IA',
      fr: 'Généré par IA',
      de: 'KI-generiert'
    },
    imported: {
      en: 'Imported',
      es: 'Importado',
      it: 'Importato',
      fr: 'Importé',
      de: 'Importiert'
    },
    level: {
      en: 'Level',
      es: 'Nivel',
      it: 'Livello',
      fr: 'Niveau',
      de: 'Stufe'
    },
    official: {
      en: 'Official/Registered',
      es: 'Oficial/Registrado',
      it: 'Ufficiale/Registrato',
      fr: 'Officiel/Enregistré',
      de: 'Offiziell/Registriert'
    },
    traditional: {
      en: 'Traditional',
      es: 'Tradicional',
      it: 'Tradizionale',
      fr: 'Traditionnel',
      de: 'Traditionell'
    },
    localSource: {
      en: 'Local Source',
      es: 'Fuente local',
      it: 'Fonte locale',
      fr: 'Source locale',
      de: 'Lokale Quelle'
    },
    widelyRecognized: {
      en: 'Widely Recognized',
      es: 'Ampliamente reconocido',
      it: 'Ampiamente riconosciuto',
      fr: 'Largement reconnu',
      de: 'Weit anerkannt'
    },
    modernAdapted: {
      en: 'Modern/Adapted',
      es: 'Moderno/Adaptado',
      it: 'Moderno/Adattato',
      fr: 'Moderne/Adapté',
      de: 'Modern/Angepasst'
    },
    ingredients: {
      en: 'ingredients',
      es: 'ingredientes',
      it: 'ingredienti',
      fr: 'ingrédients',
      de: 'Zutaten'
    }
  },

  // ============================================
  // REVIEWS
  // ============================================
  review: {
    title: {
      en: 'Ratings & Reviews',
      es: 'Calificaciones y Reseñas',
      it: 'Valutazioni e Recensioni',
      fr: 'Notes et Avis',
      de: 'Bewertungen und Rezensionen'
    },
    rating: {
      en: 'rating',
      es: 'calificación',
      it: 'valutazione',
      fr: 'note',
      de: 'Bewertung'
    },
    ratings: {
      en: 'ratings',
      es: 'calificaciones',
      it: 'valutazioni',
      fr: 'notes',
      de: 'Bewertungen'
    },
    beFirstToRate: {
      en: 'Be the first to rate this recipe!',
      es: '¡Sé el primero en calificar esta receta!',
      it: 'Sii il primo a valutare questa ricetta!',
      fr: 'Soyez le premier à noter cette recette !',
      de: 'Sei der Erste, der dieses Rezept bewertet!'
    },
    shareExperience: {
      en: 'Share your experience with this recipe',
      es: 'Comparte tu experiencia con esta receta',
      it: 'Condividi la tua esperienza con questa ricetta',
      fr: 'Partagez votre expérience avec cette recette',
      de: 'Teile deine Erfahrung mit diesem Rezept'
    },
    yourRating: {
      en: 'Your Rating',
      es: 'Tu Calificación',
      it: 'La Tua Valutazione',
      fr: 'Votre Note',
      de: 'Deine Bewertung'
    },
    yourReview: {
      en: 'Your Review (optional)',
      es: 'Tu Reseña (opcional)',
      it: 'La Tua Recensione (opzionale)',
      fr: 'Votre Avis (facultatif)',
      de: 'Deine Rezension (optional)'
    },
    placeholder: {
      en: 'Share your thoughts about this recipe...',
      es: 'Comparte tus pensamientos sobre esta receta...',
      it: 'Condividi i tuoi pensieri su questa ricetta...',
      fr: 'Partagez vos impressions sur cette recette...',
      de: 'Teile deine Gedanken zu diesem Rezept...'
    },
    submit: {
      en: 'Submit Review',
      es: 'Enviar Reseña',
      it: 'Invia Recensione',
      fr: 'Soumettre l\'Avis',
      de: 'Bewertung Abschicken'
    },
    submitting: {
      en: 'Submitting...',
      es: 'Enviando...',
      it: 'Invio in corso...',
      fr: 'Envoi en cours...',
      de: 'Wird gesendet...'
    },
    recentReviews: {
      en: 'Recent Reviews',
      es: 'Reseñas Recientes',
      it: 'Recensioni Recenti',
      fr: 'Avis Récents',
      de: 'Neueste Bewertungen'
    },
    noReviews: {
      en: 'No reviews yet. Be the first to share your thoughts!',
      es: '¡Aún no hay reseñas. Sé el primero en compartir tus pensamientos!',
      it: 'Ancora nessuna recensione. Sii il primo a condividere i tuoi pensieri!',
      fr: 'Pas encore d\'avis. Soyez le premier à partager vos impressions !',
      de: 'Noch keine Bewertungen. Sei der Erste, der seine Gedanken teilt!'
    },
    thankYou: {
      en: 'Thank you for your review!',
      es: '¡Gracias por tu reseña!',
      it: 'Grazie per la tua recensione!',
      fr: 'Merci pour votre avis !',
      de: 'Vielen Dank für deine Bewertung!'
    },
    selectRating: {
      en: 'Please select a rating',
      es: 'Por favor selecciona una calificación',
      it: 'Per favore seleziona una valutazione',
      fr: 'Veuillez sélectionner une note',
      de: 'Bitte wähle eine Bewertung'
    },
    submitError: {
      en: 'Failed to submit review. Please try again.',
      es: 'Error al enviar la reseña. Por favor, inténtalo de nuevo.',
      it: 'Invio della recensione fallito. Per favore riprova.',
      fr: 'Échec de l\'envoi de l\'avis. Veuillez réessayer.',
      de: 'Bewertung konnte nicht gesendet werden. Bitte versuche es erneut.'
    },
    star: {
      en: 'star',
      es: 'estrella',
      it: 'stella',
      fr: 'étoile',
      de: 'Stern'
    },
    stars: {
      en: 'stars',
      es: 'estrellas',
      it: 'stelle',
      fr: 'étoiles',
      de: 'Sterne'
    },
    loginRequired: {
      en: 'You must be logged in to leave a review.',
      es: 'Debes iniciar sesión para dejar una reseña.',
      it: 'Devi effettuare l\'accesso per lasciare una recensione.',
      fr: 'Vous devez être connecté pour laisser un avis.',
      de: 'Du musst angemeldet sein, um eine Bewertung zu hinterlassen.'
    },
    editReview: {
      en: 'Edit Review',
      es: 'Editar Reseña',
      it: 'Modifica Recensione',
      fr: 'Modifier l\'Avis',
      de: 'Bewertung Bearbeiten'
    },
    deleteReview: {
      en: 'Delete Review',
      es: 'Eliminar Reseña',
      it: 'Elimina Recensione',
      fr: 'Supprimer l\'Avis',
      de: 'Bewertung Löschen'
    },
    deleteConfirm: {
      en: 'Are you sure you want to delete your review?',
      es: '¿Estás seguro de que quieres eliminar tu reseña?',
      it: 'Sei sicuro di voler eliminare la tua recensione?',
      fr: 'Êtes-vous sûr de vouloir supprimer votre avis ?',
      de: 'Bist du sicher, dass du deine Bewertung löschen möchtest?'
    },
    updating: {
      en: 'Updating...',
      es: 'Actualizando...',
      it: 'Aggiornamento...',
      fr: 'Mise à jour...',
      de: 'Wird aktualisiert...'
    },
    deleteError: {
      en: 'Failed to delete review. Please try again.',
      es: 'Error al eliminar la reseña. Por favor, inténtalo de nuevo.',
      it: 'Eliminazione della recensione fallita. Per favore riprova.',
      fr: 'Échec de la suppression de l\'avis. Veuillez réessayer.',
      de: 'Bewertung konnte nicht gelöscht werden. Bitte versuche es erneut.'
    },
    minLength: {
      en: 'Minimum 10 characters',
      es: 'Mínimo 10 caracteres',
      it: 'Minimo 10 caratteri',
      fr: 'Minimum 10 caractères',
      de: 'Mindestens 10 Zeichen'
    },
    tooManyReviews: {
      en: 'Too many reviews. Please wait before posting again.',
      es: 'Demasiadas reseñas. Espera antes de publicar de nuevo.',
      it: 'Troppe recensioni. Attendi prima di pubblicare di nuovo.',
      fr: 'Trop d\'avis. Veuillez patienter avant de publier à nouveau.',
      de: 'Zu viele Bewertungen. Bitte warte, bevor du erneut postest.'
    },
    ratingSubmitted: {
      en: 'Rating submitted!',
      es: '¡Calificación enviada!',
      it: 'Valutazione inviata!',
      fr: 'Note soumise !',
      de: 'Bewertung abgegeben!'
    },
    rateDish: {
      en: 'Rate this dish',
      es: 'Califica este plato',
      it: 'Valuta questo piatto',
      fr: 'Notez ce plat',
      de: 'Bewerte dieses Gericht'
    }
  },

  // ============================================
  // AUTHENTICATION
  // ============================================
  auth: {
    login: {
      en: 'Login',
      es: 'Iniciar Sesión',
      it: 'Accedi',
      fr: 'Connexion',
      de: 'Anmelden'
    },
    logout: {
      en: 'Logout',
      es: 'Cerrar Sesión',
      it: 'Esci',
      fr: 'Déconnexion',
      de: 'Abmelden'
    },
    signUp: {
      en: 'Sign Up',
      es: 'Registrarse',
      it: 'Registrati',
      fr: 'S\'inscrire',
      de: 'Registrieren'
    },
    email: {
      en: 'Email',
      es: 'Correo Electrónico',
      it: 'Email',
      fr: 'E-mail',
      de: 'E-Mail'
    },
    password: {
      en: 'Password',
      es: 'Contraseña',
      it: 'Password',
      fr: 'Mot de passe',
      de: 'Passwort'
    },
    confirmPassword: {
      en: 'Confirm Password',
      es: 'Confirmar Contraseña',
      it: 'Conferma Password',
      fr: 'Confirmer le Mot de passe',
      de: 'Passwort Bestätigen'
    },
    username: {
      en: 'Username',
      es: 'Nombre de Usuario',
      it: 'Nome Utente',
      fr: 'Nom d\'utilisateur',
      de: 'Benutzername'
    },
    forgotPassword: {
      en: 'Forgot password?',
      es: '¿Olvidaste tu contraseña?',
      it: 'Password dimenticata?',
      fr: 'Mot de passe oublié ?',
      de: 'Passwort vergessen?'
    },
    noAccount: {
      en: 'Don\'t have an account?',
      es: '¿No tienes una cuenta?',
      it: 'Non hai un account?',
      fr: 'Vous n\'avez pas de compte ?',
      de: 'Noch kein Konto?'
    },
    haveAccount: {
      en: 'Already have an account?',
      es: '¿Ya tienes una cuenta?',
      it: 'Hai già un account?',
      fr: 'Vous avez déjà un compte ?',
      de: 'Bereits ein Konto?'
    },
    continueWithGoogle: {
      en: 'Continue with Google',
      es: 'Continuar con Google',
      it: 'Continua con Google',
      fr: 'Continuer avec Google',
      de: 'Mit Google fortfahren'
    },
    orContinueWith: {
      en: 'or continue with',
      es: 'o continúa con',
      it: 'o continua con',
      fr: 'ou continuer avec',
      de: 'oder fortfahren mit'
    },
    loginSuccess: {
      en: 'Login successful!',
      es: '¡Inicio de sesión exitoso!',
      it: 'Accesso effettuato!',
      fr: 'Connexion réussie !',
      de: 'Anmeldung erfolgreich!'
    },
    registerSuccess: {
      en: 'Account created successfully!',
      es: '¡Cuenta creada exitosamente!',
      it: 'Account creato con successo!',
      fr: 'Compte créé avec succès !',
      de: 'Konto erfolgreich erstellt!'
    },
    logoutSuccess: {
      en: 'Logged out successfully',
      es: 'Sesión cerrada exitosamente',
      it: 'Disconnessione effettuata',
      fr: 'Déconnexion réussie',
      de: 'Erfolgreich abgemeldet'
    },
    invalidCredentials: {
      en: 'Invalid email or password',
      es: 'Correo o contraseña inválidos',
      it: 'Email o password non validi',
      fr: 'E-mail ou mot de passe invalide',
      de: 'Ungültige E-Mail oder Passwort'
    },
    passwordMismatch: {
      en: 'Passwords do not match',
      es: 'Las contraseñas no coinciden',
      it: 'Le password non corrispondono',
      fr: 'Les mots de passe ne correspondent pas',
      de: 'Passwörter stimmen nicht überein'
    },
    emailExists: {
      en: 'Email already registered',
      es: 'El correo ya está registrado',
      it: 'Email già registrata',
      fr: 'E-mail déjà enregistré',
      de: 'E-Mail bereits registriert'
    },
    usernameExists: {
      en: 'Username already taken',
      es: 'El nombre de usuario ya está en uso',
      it: 'Nome utente già in uso',
      fr: 'Nom d\'utilisateur déjà pris',
      de: 'Benutzername bereits vergeben'
    },
    welcomeBack: {
      en: 'Welcome back!',
      es: '¡Bienvenido de nuevo!',
      it: 'Bentornato!',
      fr: 'Bon retour !',
      de: 'Willkommen zurück!'
    },
    createAccount: {
      en: 'Create your account',
      es: 'Crea tu cuenta',
      it: 'Crea il tuo account',
      fr: 'Créez votre compte',
      de: 'Erstelle dein Konto'
    },
    passwordRequirements: {
      en: 'Password must be at least 8 characters with letters and numbers',
      es: 'La contraseña debe tener al menos 8 caracteres con letras y números',
      it: 'La password deve contenere almeno 8 caratteri con lettere e numeri',
      fr: 'Le mot de passe doit contenir au moins 8 caractères avec des lettres et des chiffres',
      de: 'Passwort muss mindestens 8 Zeichen mit Buchstaben und Zahlen enthalten'
    },
    resetPassword: {
      en: 'Reset Password',
      es: 'Restablecer Contraseña',
      it: 'Reimposta Password',
      fr: 'Réinitialiser le Mot de passe',
      de: 'Passwort zurücksetzen'
    },
    resetDescription: {
      en: 'Enter your email and we\'ll send you a reset link.',
      es: 'Introduce tu correo y te enviaremos un enlace de restablecimiento.',
      it: 'Inserisci la tua email e ti invieremo un link per il reset.',
      fr: 'Entrez votre e-mail et nous vous enverrons un lien de réinitialisation.',
      de: 'Geben Sie Ihre E-Mail ein und wir senden Ihnen einen Reset-Link.'
    },
    resetEmailSent: {
      en: 'If an account exists with that email, a reset link has been sent.',
      es: 'Si existe una cuenta con ese correo, se ha enviado un enlace de restablecimiento.',
      it: 'Se esiste un account con quella email, è stato inviato un link di reset.',
      fr: 'Si un compte existe avec cet e-mail, un lien de réinitialisation a été envoyé.',
      de: 'Wenn ein Konto mit dieser E-Mail existiert, wurde ein Reset-Link gesendet.'
    },
    checkInbox: {
      en: 'Check your inbox and spam folder.',
      es: 'Revisa tu bandeja de entrada y la carpeta de spam.',
      it: 'Controlla la tua casella di posta e la cartella spam.',
      fr: 'Vérifiez votre boîte de réception et votre dossier spam.',
      de: 'Überprüfen Sie Ihren Posteingang und Spam-Ordner.'
    },
    sendResetLink: {
      en: 'Send Reset Link',
      es: 'Enviar Enlace de Restablecimiento',
      it: 'Invia Link di Reset',
      fr: 'Envoyer le Lien de Réinitialisation',
      de: 'Reset-Link Senden'
    },
    backToLogin: {
      en: 'Back to login',
      es: 'Volver al inicio de sesión',
      it: 'Torna al login',
      fr: 'Retour à la connexion',
      de: 'Zurück zur Anmeldung'
    },
    setNewPassword: {
      en: 'Set New Password',
      es: 'Establecer Nueva Contraseña',
      it: 'Imposta Nuova Password',
      fr: 'Définir un Nouveau Mot de passe',
      de: 'Neues Passwort Festlegen'
    },
    newPasswordDescription: {
      en: 'Choose a new password for your account.',
      es: 'Elige una nueva contraseña para tu cuenta.',
      it: 'Scegli una nuova password per il tuo account.',
      fr: 'Choisissez un nouveau mot de passe pour votre compte.',
      de: 'Wählen Sie ein neues Passwort für Ihr Konto.'
    },
    newPassword: {
      en: 'New Password',
      es: 'Nueva Contraseña',
      it: 'Nuova Password',
      fr: 'Nouveau Mot de passe',
      de: 'Neues Passwort'
    },
    passwordResetSuccess: {
      en: 'Password has been reset successfully!',
      es: '¡La contraseña se ha restablecido correctamente!',
      it: 'La password è stata reimpostata con successo!',
      fr: 'Le mot de passe a été réinitialisé avec succès !',
      de: 'Passwort wurde erfolgreich zurückgesetzt!'
    },
    resetFailed: {
      en: 'Password reset failed. The link may have expired.',
      es: 'El restablecimiento de contraseña falló. El enlace puede haber expirado.',
      it: 'Reimpostazione della password fallita. Il link potrebbe essere scaduto.',
      fr: 'La réinitialisation du mot de passe a échoué. Le lien a peut-être expiré.',
      de: 'Passwort-Reset fehlgeschlagen. Der Link ist möglicherweise abgelaufen.'
    },
    invalidResetToken: {
      en: 'Invalid or missing reset token.',
      es: 'Token de restablecimiento inválido o faltante.',
      it: 'Token di reset non valido o mancante.',
      fr: 'Jeton de réinitialisation invalide ou manquant.',
      de: 'Ungültiger oder fehlender Reset-Token.'
    },
    requestNewReset: {
      en: 'Request a new reset link',
      es: 'Solicitar un nuevo enlace de restablecimiento',
      it: 'Richiedi un nuovo link di reset',
      fr: 'Demander un nouveau lien de réinitialisation',
      de: 'Neuen Reset-Link anfordern'
    },
    invalidCallback: {
      en: 'Invalid authentication callback.',
      es: 'Callback de autenticación inválido.',
      it: 'Callback di autenticazione non valido.',
      fr: 'Callback d\'authentification invalide.',
      de: 'Ungültiger Authentifizierungs-Callback.'
    },
    completingSignIn: {
      en: 'Completing sign in...',
      es: 'Completando el inicio de sesión...',
      it: 'Completamento dell\'accesso...',
      fr: 'Connexion en cours...',
      de: 'Anmeldung wird abgeschlossen...'
    },
    loginFailed: {
      en: 'Sign in failed.',
      es: 'Error al iniciar sesión.',
      it: 'Accesso fallito.',
      fr: 'La connexion a échoué.',
      de: 'Anmeldung fehlgeschlagen.'
    },
    redirecting: {
      en: 'Redirecting...',
      es: 'Redirigiendo...',
      it: 'Reindirizzamento...',
      fr: 'Redirection...',
      de: 'Weiterleitung...'
    },
    tooManyAttempts: {
      en: 'Too many login attempts. Please try again later.',
      es: 'Demasiados intentos de inicio de sesión. Inténtalo de nuevo más tarde.',
      it: 'Troppi tentativi di accesso. Riprova più tardi.',
      fr: 'Trop de tentatives de connexion. Veuillez réessayer plus tard.',
      de: 'Zu viele Anmeldeversuche. Bitte versuchen Sie es später erneut.'
    }
  },

  // ============================================
  // SEARCH
  // ============================================
  search: {
    placeholder: {
      en: 'Search authentic recipes...',
      es: 'Buscar recetas auténticas...',
      it: 'Cerca ricette autentiche...',
      fr: 'Rechercher des recettes authentiques...',
      de: 'Authentische Rezepte suchen...'
    },
    button: {
      en: 'Search',
      es: 'Buscar',
      it: 'Cerca',
      fr: 'Rechercher',
      de: 'Suchen'
    },
    searching: {
      en: 'Searching...',
      es: 'Buscando...',
      it: 'Ricerca in corso...',
      fr: 'Recherche en cours...',
      de: 'Suche läuft...'
    },
    noResults: {
      en: 'No recipes found',
      es: 'No se encontraron recetas',
      it: 'Nessuna ricetta trovata',
      fr: 'Aucune recette trouvée',
      de: 'Keine Rezepte gefunden'
    },
    generatedSuccess: {
      en: 'Recipe generated by Sous-Chef Linguine!',
      es: '¡Receta generada por Sous-Chef Linguine!',
      it: 'Ricetta generata da Sous-Chef Linguine!',
      fr: 'Recette générée par Sous-Chef Linguine !',
      de: 'Rezept von Sous-Chef Linguine generiert!'
    },
    translatedSuccess: {
      en: 'Recipe translated to your language',
      es: 'Receta traducida a tu idioma',
      it: 'Ricetta tradotta nella tua lingua',
      fr: 'Recette traduite dans votre langue',
      de: 'Rezept in Ihre Sprache übersetzt'
    },
    failed: {
      en: 'Search failed. Please try again.',
      es: 'Búsqueda fallida. Por favor, inténtalo de nuevo.',
      it: 'Ricerca fallita. Riprova.',
      fr: 'Échec de la recherche. Veuillez réessayer.',
      de: 'Suche fehlgeschlagen. Bitte erneut versuchen.'
    }
  },

  // ============================================
  // COUNTRY NAMES
  // ============================================
  countries: {
    Spain: { en: 'Spain', es: 'España', it: 'Spagna', fr: 'Espagne', de: 'Spanien' },
    Italy: { en: 'Italy', es: 'Italia', it: 'Italia', fr: 'Italie', de: 'Italien' },
    France: { en: 'France', es: 'Francia', it: 'Francia', fr: 'France', de: 'Frankreich' },
    Germany: { en: 'Germany', es: 'Alemania', it: 'Germania', fr: 'Allemagne', de: 'Deutschland' },
    Greece: { en: 'Greece', es: 'Grecia', it: 'Grecia', fr: 'Grèce', de: 'Griechenland' },
    Portugal: { en: 'Portugal', es: 'Portugal', it: 'Portogallo', fr: 'Portugal', de: 'Portugal' },
    Albania: { en: 'Albania', es: 'Albania', it: 'Albania', fr: 'Albanie', de: 'Albanien' },
    Russia: { en: 'Russia', es: 'Rusia', it: 'Russia', fr: 'Russie', de: 'Russland' },
    Hungary: { en: 'Hungary', es: 'Hungría', it: 'Ungheria', fr: 'Hongrie', de: 'Ungarn' },
    'United Kingdom': { en: 'United Kingdom', es: 'Reino Unido', it: 'Regno Unito', fr: 'Royaume-Uni', de: 'Vereinigtes Königreich' },
    Turkey: { en: 'Turkey', es: 'Turquía', it: 'Turchia', fr: 'Turquie', de: 'Türkei' },
    Latvia: { en: 'Latvia', es: 'Letonia', it: 'Lettonia', fr: 'Lettonie', de: 'Lettland' },
    Romania: { en: 'Romania', es: 'Rumanía', it: 'Romania', fr: 'Roumanie', de: 'Rumänien' },
    Japan: { en: 'Japan', es: 'Japón', it: 'Giappone', fr: 'Japon', de: 'Japan' },
    China: { en: 'China', es: 'China', it: 'Cina', fr: 'Chine', de: 'China' },
    India: { en: 'India', es: 'India', it: 'India', fr: 'Inde', de: 'Indien' },
    Thailand: { en: 'Thailand', es: 'Tailandia', it: 'Thailandia', fr: 'Thaïlande', de: 'Thailand' },
    Vietnam: { en: 'Vietnam', es: 'Vietnam', it: 'Vietnam', fr: 'Vietnam', de: 'Vietnam' },
    'South Korea': { en: 'South Korea', es: 'Corea del Sur', it: 'Corea del Sud', fr: 'Corée du Sud', de: 'Südkorea' },
    Mexico: { en: 'Mexico', es: 'México', it: 'Messico', fr: 'Mexique', de: 'Mexiko' },
    USA: { en: 'USA', es: 'EE.UU.', it: 'USA', fr: 'États-Unis', de: 'USA' },
    Brazil: { en: 'Brazil', es: 'Brasil', it: 'Brasile', fr: 'Brésil', de: 'Brasilien' },
    Argentina: { en: 'Argentina', es: 'Argentina', it: 'Argentina', fr: 'Argentine', de: 'Argentinien' },
    Morocco: { en: 'Morocco', es: 'Marruecos', it: 'Marocco', fr: 'Maroc', de: 'Marokko' },
    Egypt: { en: 'Egypt', es: 'Egipto', it: 'Egitto', fr: 'Égypte', de: 'Ägypten' },
    Australia: { en: 'Australia', es: 'Australia', it: 'Australia', fr: 'Australie', de: 'Australien' }
  },

  // ============================================
  // CONTINENT NAMES
  // ============================================
  continents: {
    Europe: { en: 'Europe', es: 'Europa', it: 'Europa', fr: 'Europe', de: 'Europa' },
    Asia: { en: 'Asia', es: 'Asia', it: 'Asia', fr: 'Asie', de: 'Asien' },
    Americas: { en: 'Americas', es: 'Américas', it: 'Americhe', fr: 'Amériques', de: 'Amerika' },
    Africa: { en: 'Africa', es: 'África', it: 'Africa', fr: 'Afrique', de: 'Afrika' },
    'Middle East': { en: 'Middle East', es: 'Oriente Medio', it: 'Medio Oriente', fr: 'Moyen-Orient', de: 'Naher Osten' },
    Oceania: { en: 'Oceania', es: 'Oceanía', it: 'Oceania', fr: 'Océanie', de: 'Ozeanien' }
  },

  // ============================================
  // COMMON / MISC
  // ============================================
  common: {
    home: {
      en: 'Home',
      it: 'Home',
      fr: 'Accueil',
      es: 'Inicio',
      de: 'Startseite'
    },
    official: {
      en: 'Official',
      it: 'Ufficiale',
      fr: 'Officiel',
      es: 'Oficial',
      de: 'Offiziell'
    },
    traditional: {
      en: 'Traditional',
      it: 'Tradizionale',
      fr: 'Traditionnel',
      es: 'Tradicional',
      de: 'Traditionell'
    },
    local: {
      en: 'Local',
      it: 'Locale',
      fr: 'Local',
      es: 'Local',
      de: 'Lokal'
    },
    learnMore: {
      en: 'Learn More',
      it: 'Scopri di Più',
      fr: 'En Savoir Plus',
      es: 'Saber Más',
      de: 'Mehr Erfahren'
    },
    cancel: {
      en: 'Cancel',
      it: 'Annulla',
      fr: 'Annuler',
      es: 'Cancelar',
      de: 'Abbrechen'
    },
    retry: {
      en: 'Retry',
      it: 'Riprova',
      fr: 'Réessayer',
      es: 'Reintentar',
      de: 'Erneut versuchen'
    }
  },

  // ============================================
  // BADGES (STANDARDIZED)
  // ============================================
  badges: {
    officiallyRecognized: {
      en: 'Officially Recognized',
      it: 'Ufficialmente Riconosciuto',
      fr: 'Officiellement Reconnu',
      es: 'Oficialmente Reconocido',
      de: 'Offiziell Anerkannt'
    },
    traditionVerified: {
      en: 'Tradition-Verified',
      it: 'Verificato dalla Tradizione',
      fr: 'Vérifié par la Tradition',
      es: 'Verificado por Tradición',
      de: 'Traditions-Verifiziert'
    },
    traditional: {
      en: 'Traditional',
      it: 'Tradizionale',
      fr: 'Traditionnel',
      es: 'Tradicional',
      de: 'Traditionell'
    }
  },

  // ============================================
  // FAVORITES PAGE
  // ============================================
  favorites: {
    title: {
      en: 'My Favorites',
      it: 'I Miei Preferiti',
      fr: 'Mes Favoris',
      es: 'Mis Favoritos',
      de: 'Meine Favoriten'
    },
    loginRequired: {
      en: 'Sign in to save favorites',
      it: 'Accedi per salvare i preferiti',
      fr: 'Connectez-vous pour sauvegarder des favoris',
      es: 'Inicia sesión para guardar favoritos',
      de: 'Anmelden um Favoriten zu speichern'
    },
    loginDescription: {
      en: 'Create an account to start saving your favorite recipes from around the world.',
      it: 'Crea un account per iniziare a salvare le tue ricette preferite da tutto il mondo.',
      fr: 'Créez un compte pour commencer à sauvegarder vos recettes préférées du monde entier.',
      es: 'Crea una cuenta para guardar tus recetas favoritas de todo el mundo.',
      de: 'Erstellen Sie ein Konto, um Ihre Lieblingsrezepte aus aller Welt zu speichern.'
    },
    empty: {
      en: 'No favorites yet',
      it: 'Nessun preferito ancora',
      fr: 'Pas encore de favoris',
      es: 'Aún no hay favoritos',
      de: 'Noch keine Favoriten'
    },
    emptyDescription: {
      en: 'Start exploring recipes and tap the heart to save them here.',
      it: 'Inizia a esplorare le ricette e tocca il cuore per salvarle qui.',
      fr: 'Commencez à explorer les recettes et appuyez sur le cœur pour les sauvegarder ici.',
      es: 'Empieza a explorar recetas y toca el corazón para guardarlas aquí.',
      de: 'Beginnen Sie Rezepte zu entdecken und tippen Sie auf das Herz, um sie hier zu speichern.'
    },
    exploreRecipes: {
      en: 'Explore Recipes',
      it: 'Esplora Ricette',
      fr: 'Explorer les Recettes',
      es: 'Explorar Recetas',
      de: 'Rezepte Entdecken'
    }
  },

  // ============================================
  // HOMEPAGE EDITORIAL
  // ============================================
  homepage: {
    valueStrip: {
      main: {
        en: 'A curated collection of authentic recipes, selected for tradition — not volume.',
        it: 'Una collezione curata di ricette autentiche, selezionate per tradizione — non per quantità.',
        fr: 'Une collection soignée de recettes authentiques, sélectionnées pour la tradition — pas pour le volume.',
        es: 'Una colección curada de recetas auténticas, seleccionadas por tradición — no por volumen.',
        de: 'Eine kuratierte Sammlung authentischer Rezepte, ausgewählt nach Tradition — nicht nach Menge.'
      },
      curated: {
        en: 'Curated global recipes',
        it: 'Ricette globali curate',
        fr: 'Recettes mondiales sélectionnées',
        es: 'Recetas globales curadas',
        de: 'Kuratierte globale Rezepte'
      },
      validated: {
        en: 'Community-validated for authenticity',
        it: 'Validate dalla comunità per autenticità',
        fr: 'Validées par la communauté pour authenticité',
        es: 'Validadas por la comunidad para autenticidad',
        de: 'Von der Community auf Authentizität geprüft'
      },
      accuracy: {
        en: 'Cultural accuracy over popularity',
        it: 'Accuratezza culturale prima della popolarità',
        fr: 'Précision culturelle avant popularité',
        es: 'Precisión cultural sobre popularidad',
        de: 'Kulturelle Genauigkeit vor Popularität'
      }
    },
    hero: {
      title: {
        en: 'Sous Chef Linguine',
        it: 'Sous Chef Linguine',
        fr: 'Sous Chef Linguine',
        es: 'Sous Chef Linguine',
        de: 'Sous Chef Linguine'
      },
      subtitle: {
        en: 'The culinary archive of authentic regional recipes',
        it: 'L\'archivio culinario delle ricette regionali autentiche',
        fr: 'L\'archive culinaire des recettes régionales authentiques',
        es: 'El archivo culinario de recetas regionales auténticas',
        de: 'Das kulinarische Archiv authentischer regionaler Rezepte'
      },
      searchPlaceholder: {
        en: 'Search by recipe, ingredient, region, or dish type',
        it: 'Cerca per ricetta, ingrediente, regione o tipo di piatto',
        fr: 'Rechercher par recette, ingrédient, région ou type de plat',
        es: 'Buscar por receta, ingrediente, región o tipo de plato',
        de: 'Suche nach Rezept, Zutat, Region oder Gerichtart'
      },
      searchHelper: {
        en: 'Can\'t find what you\'re looking for? Try our cultural search — dishes often have different names across regions.',
        it: 'Non trovi quello che cerchi? Prova la nostra ricerca culturale — i piatti spesso hanno nomi diversi nelle varie regioni.',
        fr: 'Vous ne trouvez pas ce que vous cherchez ? Essayez notre recherche culturelle — les plats ont souvent des noms différents selon les régions.',
        es: '¿No encuentras lo que buscas? Prueba nuestra búsqueda cultural — los platos a menudo tienen nombres diferentes en las regiones.',
        de: 'Nicht gefunden? Versuchen Sie unsere kulturelle Suche — Gerichte haben oft verschiedene Namen in den Regionen.'
      },
      searchButton: {
        en: 'Search',
        it: 'Cerca',
        fr: 'Rechercher',
        es: 'Buscar',
        de: 'Suchen'
      },
      exploreRecipe: {
        en: 'Explore recipe',
        it: 'Esplora ricetta',
        fr: 'Explorer la recette',
        es: 'Explorar receta',
        de: 'Rezept erkunden'
      }
    },
    authenticity: {
      title: {
        en: 'How Authenticity Works',
        it: 'Come Funziona l\'Autenticità',
        fr: 'Comment Fonctionne l\'Authenticité',
        es: 'Cómo Funciona la Autenticidad',
        de: 'Wie Authentizität Funktioniert'
      },
      step1Title: {
        en: 'Curated Selection',
        it: 'Selezione Curata',
        fr: 'Sélection Soignée',
        es: 'Selección Curada',
        de: 'Kuratierte Auswahl'
      },
      step1Text: {
        en: 'Recipes are selected based on historical and regional authenticity.',
        it: 'Le ricette sono selezionate in base all\'autenticità storica e regionale.',
        fr: 'Les recettes sont sélectionnées selon l\'authenticité historique et régionale.',
        es: 'Las recetas se seleccionan según la autenticidad histórica y regional.',
        de: 'Rezepte werden nach historischer und regionaler Authentizität ausgewählt.'
      },
      step2Title: {
        en: 'Community Validation',
        it: 'Validazione della Comunità',
        fr: 'Validation Communautaire',
        es: 'Validación Comunitaria',
        de: 'Community-Validierung'
      },
      step2Text: {
        en: 'Users vote on how faithfully a recipe respects its traditional form.',
        it: 'Gli utenti votano quanto fedelmente una ricetta rispetta la sua forma tradizionale.',
        fr: 'Les utilisateurs votent sur la fidélité d\'une recette à sa forme traditionnelle.',
        es: 'Los usuarios votan qué tan fielmente una receta respeta su forma tradicional.',
        de: 'Benutzer bewerten, wie treu ein Rezept seiner traditionellen Form entspricht.'
      },
      step3Title: {
        en: 'Cultural Correction',
        it: 'Correzione Culturale',
        fr: 'Correction Culturelle',
        es: 'Corrección Cultural',
        de: 'Kulturelle Korrektur'
      },
      step3Text: {
        en: 'Users may suggest corrections when a recipe does not meet tradition.',
        it: 'Gli utenti possono suggerire correzioni quando una ricetta non rispetta la tradizione.',
        fr: 'Les utilisateurs peuvent suggérer des corrections quand une recette ne respecte pas la tradition.',
        es: 'Los usuarios pueden sugerir correcciones cuando una receta no cumple con la tradición.',
        de: 'Benutzer können Korrekturen vorschlagen, wenn ein Rezept der Tradition nicht entspricht.'
      }
    },
    browseContinent: {
      title: {
        en: 'Browse by Continent',
        it: 'Sfoglia per Continente',
        fr: 'Parcourir par Continent',
        es: 'Explorar por Continente',
        de: 'Nach Kontinent Durchsuchen'
      }
    },
    browseDishType: {
      title: {
        en: 'Browse by Dish Type',
        it: 'Sfoglia per Tipo di Piatto',
        fr: 'Parcourir par Type de Plat',
        es: 'Explorar por Tipo de Plato',
        de: 'Nach Gerichtart Durchsuchen'
      }
    },
    moreToDiscover: {
      title: {
        en: 'More to Discover',
        it: 'Ancora da Scoprire',
        fr: 'Encore Plus à Découvrir',
        es: 'Más por Descubrir',
        de: 'Noch Mehr Entdecken'
      }
    },
    dishTypes: {
      appetizer: { en: 'Appetizers', it: 'Antipasti', fr: 'Entrées', es: 'Aperitivos', de: 'Vorspeisen' },
      aperitif: { en: 'Aperitif & Small Plates', it: 'Aperitivi e Stuzzichini', fr: 'Apéritifs et Petites Assiettes', es: 'Aperitivos y Tapas', de: 'Aperitifs und Kleine Teller' },
      firstCourse: { en: 'First Courses', it: 'Primi Piatti', fr: 'Premiers Plats', es: 'Primeros Platos', de: 'Erste Gänge' },
      mainCourse: { en: 'Main Courses', it: 'Secondi Piatti', fr: 'Plats Principaux', es: 'Platos Principales', de: 'Hauptgerichte' },
      sideDish: { en: 'Side Dishes', it: 'Contorni', fr: 'Accompagnements', es: 'Guarniciones', de: 'Beilagen' },
      dessert: { en: 'Desserts', it: 'Dolci', fr: 'Desserts', es: 'Postres', de: 'Desserts' },
      streetFood: { en: 'Street Food', it: 'Cibo di Strada', fr: 'Street Food', es: 'Comida Callejera', de: 'Straßenessen' },
      festive: { en: 'Festive & Ritual Dishes', it: 'Piatti Festivi e Rituali', fr: 'Plats Festifs et Rituels', es: 'Platos Festivos y Rituales', de: 'Festliche und Rituelle Gerichte' }
    },
    curatedRecipes: {
      title: {
        en: 'Recipes selected for authenticity',
        it: 'Ricette selezionate per autenticità',
        fr: 'Recettes sélectionnées pour authenticité',
        es: 'Recetas seleccionadas por autenticidad',
        de: 'Rezepte ausgewählt für Authentizität'
      },
      exploreAll: {
        en: 'Explore Full Collection',
        it: 'Esplora Collezione Completa',
        fr: 'Explorer la Collection Complète',
        es: 'Explorar Colección Completa',
        de: 'Vollständige Sammlung Erkunden'
      },
      loading: {
        en: 'Loading...',
        it: 'Caricamento...',
        fr: 'Chargement...',
        es: 'Cargando...',
        de: 'Wird geladen...'
      }
    },
    footer: {
      tagline: {
        en: 'Preserving culinary heritage, one recipe at a time.',
        it: 'Preservare il patrimonio culinario, una ricetta alla volta.',
        fr: 'Préserver le patrimoine culinaire, une recette à la fois.',
        es: 'Preservando el patrimonio culinario, una receta a la vez.',
        de: 'Kulinarisches Erbe bewahren, ein Rezept nach dem anderen.'
      },
      editorialStandards: {
        en: 'Our Editorial Standards',
        it: 'I Nostri Standard Editoriali',
        fr: 'Nos Standards Éditoriaux',
        es: 'Nuestros Estándares Editoriales',
        de: 'Unsere Redaktionellen Standards'
      }
    }
  },
  // ============================================
  // HOMEPAGE (new Sona design keys)
  // ============================================
  homepage: {
    hero: {
      title: {
        en: 'Sous Chef Linguine',
        it: 'Sous Chef Linguine',
        fr: 'Sous Chef Linguine',
        es: 'Sous Chef Linguine',
        de: 'Sous Chef Linguine'
      },
      subtitle: {
        en: 'The Authentic Global Recipe Engine',
        it: 'Il Motore di Ricette Globali Autentiche',
        fr: 'Le Moteur de Recettes Authentiques du Monde',
        es: 'El Motor de Recetas Auténticas del Mundo',
        de: 'Die Authentische Globale Rezept-Suchmaschine'
      },
      searchPlaceholder: {
        en: 'Search by recipe, ingredient, region, or dish type...',
        it: 'Cerca per ricetta, ingrediente, regione o tipo di piatto...',
        fr: 'Rechercher par recette, ingrédient, région ou type de plat...',
        es: 'Buscar por receta, ingrediente, región o tipo de plato...',
        de: 'Suche nach Rezept, Zutat, Region oder Gerichtart...'
      },
      searchHelper: {
        en: 'Try "paella valenciana", "carbonara", "pad thai"…',
        it: 'Prova "paella valenciana", "carbonara", "pad thai"…',
        fr: 'Essayez "paella valenciana", "carbonara", "pad thai"…',
        es: 'Prueba "paella valenciana", "carbonara", "pad thai"…',
        de: 'Versuche "paella valenciana", "carbonara", "pad thai"…'
      },
      exploreRecipe: {
        en: 'Explore this recipe',
        it: 'Scopri questa ricetta',
        fr: 'Découvrir cette recette',
        es: 'Explorar esta receta',
        de: 'Dieses Rezept entdecken'
      }
    },
    valueStrip: {
      curated: {
        en: 'Curated & Verified',
        it: 'Curate e Verificate',
        fr: 'Sélectionnées & Vérifiées',
        es: 'Curadas y Verificadas',
        de: 'Kuratiert & Verifiziert'
      },
      validated: {
        en: 'Community Validated',
        it: 'Validate dalla Comunità',
        fr: 'Validées par la Communauté',
        es: 'Validadas por la Comunidad',
        de: 'Von der Community Validiert'
      },
      accuracy: {
        en: 'Cultural Accuracy',
        it: 'Accuratezza Culturale',
        fr: 'Exactitude Culturelle',
        es: 'Precisión Cultural',
        de: 'Kulturelle Genauigkeit'
      }
    },
    authenticity: {
      title: {
        en: 'How Authenticity Works',
        it: 'Come Funziona l\'Autenticità',
        fr: 'Comment Fonctionne l\'Authenticité',
        es: 'Cómo Funciona la Autenticidad',
        de: 'Wie Authentizität Funktioniert'
      },
      step1Title: {
        en: 'Research',
        it: 'Ricerca',
        fr: 'Recherche',
        es: 'Investigación',
        de: 'Recherche'
      },
      step1Text: {
        en: 'Each recipe is sourced from traditional regional origins and cross-referenced with local culinary authorities.',
        it: 'Ogni ricetta proviene da origini regionali tradizionali ed è verificata con autorità culinarie locali.',
        fr: 'Chaque recette provient d\'origines régionales traditionnelles et est recoupée avec les autorités culinaires locales.',
        es: 'Cada receta proviene de orígenes regionales tradicionales y se contrasta con autoridades culinarias locales.',
        de: 'Jedes Rezept stammt aus traditionellen regionalen Ursprüngen und wird mit lokalen kulinarischen Autoritäten abgeglichen.'
      },
      step2Title: {
        en: 'Validation',
        it: 'Validazione',
        fr: 'Validation',
        es: 'Validación',
        de: 'Validierung'
      },
      step2Text: {
        en: 'Community members and culinary experts review each recipe for faithfulness to tradition.',
        it: 'Membri della comunità ed esperti culinari esaminano ogni ricetta per la fedeltà alla tradizione.',
        fr: 'Les membres de la communauté et les experts culinaires examinent chaque recette pour sa fidélité à la tradition.',
        es: 'Miembros de la comunidad y expertos culinarios revisan cada receta por su fidelidad a la tradición.',
        de: 'Community-Mitglieder und kulinarische Experten prüfen jedes Rezept auf Traditionstreue.'
      },
      step3Title: {
        en: 'Certification',
        it: 'Certificazione',
        fr: 'Certification',
        es: 'Certificación',
        de: 'Zertifizierung'
      },
      step3Text: {
        en: 'Recipes receive an authenticity level based on verified sourcing, technique accuracy, and cultural integrity.',
        it: 'Le ricette ricevono un livello di autenticità basato su origine verificata, accuratezza tecnica e integrità culturale.',
        fr: 'Les recettes reçoivent un niveau d\'authenticité basé sur l\'approvisionnement vérifié, la précision technique et l\'intégrité culturelle.',
        es: 'Las recetas reciben un nivel de autenticidad basado en origen verificado, precisión técnica e integridad cultural.',
        de: 'Rezepte erhalten ein Authentizitätsniveau basierend auf verifizierter Herkunft, technischer Genauigkeit und kultureller Integrität.'
      }
    },
    browseContinent: {
      title: {
        en: 'Browse by Continent',
        it: 'Esplora per Continente',
        fr: 'Parcourir par Continent',
        es: 'Explorar por Continente',
        de: 'Nach Kontinent Durchsuchen'
      }
    },
    browseDishType: {
      title: {
        en: 'Browse by Dish Type',
        it: 'Esplora per Tipo di Piatto',
        fr: 'Parcourir par Type de Plat',
        es: 'Explorar por Tipo de Plato',
        de: 'Nach Gerichttyp Durchsuchen'
      }
    },
    moreToDiscover: {
      title: {
        en: 'More to Discover',
        it: 'Ancora da Scoprire',
        fr: 'Encore Plus à Découvrir',
        es: 'Más por Descubrir',
        de: 'Noch Mehr Entdecken'
      }
    },
    dishTypes: {
      appetizer: {
        en: 'Appetizer',
        it: 'Antipasto',
        fr: 'Entrée',
        es: 'Aperitivo',
        de: 'Vorspeise'
      },
      aperitif: {
        en: 'Aperitif',
        it: 'Aperitivo',
        fr: 'Apéritif',
        es: 'Aperitivo',
        de: 'Aperitif'
      },
      firstCourse: {
        en: 'First Course',
        it: 'Primo Piatto',
        fr: 'Premier Plat',
        es: 'Primer Plato',
        de: 'Erster Gang'
      },
      mainCourse: {
        en: 'Main Course',
        it: 'Secondo Piatto',
        fr: 'Plat Principal',
        es: 'Plato Principal',
        de: 'Hauptgericht'
      },
      sideDish: {
        en: 'Side Dish',
        it: 'Contorno',
        fr: 'Accompagnement',
        es: 'Guarnición',
        de: 'Beilage'
      },
      dessert: {
        en: 'Dessert',
        it: 'Dolce',
        fr: 'Dessert',
        es: 'Postre',
        de: 'Dessert'
      },
      streetFood: {
        en: 'Street Food',
        it: 'Cibo di Strada',
        fr: 'Cuisine de Rue',
        es: 'Comida Callejera',
        de: 'Straßenessen'
      },
      festive: {
        en: 'Festive',
        it: 'Festivo',
        fr: 'Festif',
        es: 'Festivo',
        de: 'Festlich'
      }
    },
    curatedRecipes: {
      title: {
        en: 'Curated Authentic Recipes',
        it: 'Ricette Autentiche Selezionate',
        fr: 'Recettes Authentiques Sélectionnées',
        es: 'Recetas Auténticas Seleccionadas',
        de: 'Kuratierte Authentische Rezepte'
      },
      loading: {
        en: 'Loading recipes…',
        it: 'Caricamento ricette…',
        fr: 'Chargement des recettes…',
        es: 'Cargando recetas…',
        de: 'Rezepte werden geladen…'
      },
      exploreAll: {
        en: 'Explore All Recipes',
        it: 'Esplora Tutte le Ricette',
        fr: 'Explorer Toutes les Recettes',
        es: 'Explorar Todas las Recetas',
        de: 'Alle Rezepte Entdecken'
      },
      emptyTitle: {
        en: 'Explore our growing archive of authentic recipes',
        it: 'Esplora il nostro archivio in crescita di ricette autentiche',
        fr: 'Explorez nos archives grandissantes de recettes authentiques',
        es: 'Explora nuestro archivo en crecimiento de recetas auténticas',
        de: 'Entdecken Sie unser wachsendes Archiv authentischer Rezepte'
      },
      browseCollection: {
        en: 'Browse Collection',
        it: 'Sfoglia la Collezione',
        fr: 'Parcourir la Collection',
        es: 'Explorar Colección',
        de: 'Sammlung Durchsuchen'
      }
    },
    footer: {
      tagline: {
        en: 'Preserving culinary heritage, one recipe at a time.',
        it: 'Preservare il patrimonio culinario, una ricetta alla volta.',
        fr: 'Préserver le patrimoine culinaire, une recette à la fois.',
        es: 'Preservando el patrimonio culinario, una receta a la vez.',
        de: 'Kulinarisches Erbe bewahren, ein Rezept nach dem anderen.'
      },
      editorialStandards: {
        en: 'Our Editorial Standards',
        it: 'I Nostri Standard Editoriali',
        fr: 'Nos Standards Éditoriaux',
        es: 'Nuestros Estándares Editoriales',
        de: 'Unsere Redaktionellen Standards'
      }
    }
  },
  // ============================================
  // CONTINENTS (both cased for API compat + UI keys)
  // ============================================
  continents: {
    europe:   { en: 'Europe',   it: 'Europa',   fr: 'Europe',    es: 'Europa',   de: 'Europa' },
    Europe:   { en: 'Europe',   it: 'Europa',   fr: 'Europe',    es: 'Europa',   de: 'Europa' },
    asia:     { en: 'Asia',     it: 'Asia',     fr: 'Asie',      es: 'Asia',     de: 'Asien' },
    Asia:     { en: 'Asia',     it: 'Asia',     fr: 'Asie',      es: 'Asia',     de: 'Asien' },
    americas: { en: 'Americas', it: 'Americhe', fr: 'Amériques', es: 'Américas', de: 'Amerika' },
    Americas: { en: 'Americas', it: 'Americhe', fr: 'Amériques', es: 'Américas', de: 'Amerika' },
    africa:   { en: 'Africa',   it: 'Africa',   fr: 'Afrique',   es: 'África',   de: 'Afrika' },
    Africa:   { en: 'Africa',   it: 'Africa',   fr: 'Afrique',   es: 'África',   de: 'Afrika' },
    oceania:  { en: 'Oceania',  it: 'Oceania',  fr: 'Océanie',   es: 'Oceanía',  de: 'Ozeanien' },
    Oceania:  { en: 'Oceania',  it: 'Oceania',  fr: 'Océanie',   es: 'Oceanía',  de: 'Ozeanien' },
    'Middle East': { en: 'Middle East', it: 'Medio Oriente', fr: 'Moyen-Orient', es: 'Medio Oriente', de: 'Naher Osten' }
  },
  // ============================================
  // AUTHENTICITY LABELS
  // ============================================
  authenticityLabels: {
    official:    { en: 'Official',    it: 'Ufficiale',    fr: 'Officiel',      es: 'Oficial',      de: 'Offiziell' },
    traditional: { en: 'Traditional', it: 'Tradizionale', fr: 'Traditionnel',  es: 'Tradicional',  de: 'Traditionell' },
    modern:      { en: 'Modern',      it: 'Moderno',      fr: 'Moderne',       es: 'Moderno',      de: 'Modern' }
  },
  // ============================================
  // INGREDIENT TABLE UI
  // ============================================
  ingredientTable: {
    amount:  { en: 'Amount',  it: 'Quantità',  fr: 'Quantité', es: 'Cantidad',  de: 'Menge' },
    notes:   { en: 'Notes',   it: 'Note',      fr: 'Notes',    es: 'Notas',     de: 'Hinweise' },
    unknown: { en: 'Unknown', it: 'Sconosciuto', fr: 'Inconnu', es: 'Desconocido', de: 'Unbekannt' }
  }
};

/**
 * Get translated text by key path
 * 
 * CRITICAL: NO SILENT FALLBACK TO ENGLISH
 * - In DEV mode: Returns [MISSING_TRANSLATION: key] for missing translations
 * - In PROD mode: Still returns the visible marker (build should fail with missing keys)
 * 
 * @param {string} path - Dot-separated path to the translation key (e.g., 'home.title')
 * @param {string} lang - Language code (en, it, fr, es, de)
 * @returns {string} Translated text or visible error marker if not found
 */
export const t = (path, lang = 'en') => {
  const keys = path.split('.');
  let result = translations;
  
  for (const key of keys) {
    if (result && typeof result === 'object' && key in result) {
      result = result[key];
    } else {
      // KEY NOT FOUND - show visible marker
      console.error(`[i18n] Translation key not found: ${path}`);
      return `[MISSING_KEY: ${path}]`;
    }
  }
  
  // Check if translation exists for requested language
  if (typeof result === 'object' && lang in result) {
    return result[lang];
  }
  
  // CRITICAL: NO SILENT FALLBACK
  // If the key exists but translation for this language is missing
  if (typeof result === 'object') {
    console.error(`[i18n] Missing ${lang.toUpperCase()} translation for: ${path}`);
    return `[MISSING_${lang.toUpperCase()}: ${path}]`;
  }
  
  return `[INVALID_KEY: ${path}]`;
};

export default translations;
